import React, { Component } from 'react';
import {
  Text,
  View,
  Dimensions,Platform,
  Image,
  TouchableHighlight,ActivityIndicator,Clipboard,
  FlatList,ScrollView,Linking,Alert
} from 'react-native';
import {StyleContext, styleInfo} from '../styleC';
import strings from '../strings';
import MavSelector from './mavSelector';
import MavTextInput from './mavTextInput';
import MavSearch from './mavSearch';
import example from '../example';
import MavButton from './mavButton';
import firebase from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";
import MavViewMore from './mavViewMore';
import MavAlert from './mavAlert';
import info from '../info';
import moneyList from '../moneyList';
import Modal from './modal';
import BookingView from './bookingView';
import MavMiniButton from './mavMiniButton';
const timer = require('react-native-timer');
var searchBillWithNumberTimer=undefined;


class HeaderRight extends Component {
render() {
    return (
      <StyleContext.Consumer>{style => <View style={{flexDirection:"row", alignItems:"center"}}>

           {(this.props.info.viewSearch==false && this.props.info.moneySymbole!=undefined)  && <TouchableHighlight style={{ marginRight:15}} underlayColor={"#FFFFFF00"} onPress={() => { this.props.info.filterMoney(); }}>
                  <Text style={{fontSize: 14,color:style.textInputColor}}>{(this.props.info.moneySymbole!=undefined)?strings.in+" "+this.props.info.moneySymbole:""}</Text>
              </TouchableHighlight>}


              {(this.props.info.stripeManualOnRevenus==true && this.props.info.viewSearch==false) && <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => { this.props.info.transfertRevenu(); }}>
                  <Image source={(style.mode=="dark")?require('../assets/transfertMoney_white.png'):require('../assets/transfertMoney_black.png')} style={{ width: 25, height: 25 }}/>
              </TouchableHighlight>}

              {(this.props.info.disableSearch!==true && this.props.info.viewSearch==false) && <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => { this.props.info.changeViewSearch(); }}>
                  <Image source={(style.mode=="dark")?require('../assets/search_white.png'):require('../assets/search_black.png')} style={{ width: 20, height: 20 }}/>
              </TouchableHighlight>}

              
              {this.props.info.viewSearch==true && <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => { this.props.info.changeViewSearch(); }}>
                  <Text style={{fontSize: 14,color:style.textInputColor}}>{strings.cancel}</Text>
              </TouchableHighlight>}

        </View>

        }</StyleContext.Consumer>
      )
  }
}







export default class App extends Component {
  constructor(props) { 
    super(props);
    
    var infoMoney=this.findMoney();
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
    this.state = {
      hidePriceRaceForDriver:(params!=undefined && params.hidePriceRaceForDriver==true)?true:false,
      billWithoutDetail:(params!=undefined && params.billWithoutDetail==true)?true:false,
      stripeManualOnRevenus:(params!=undefined && (params.viewSelect==undefined || params.viewSelect=="revenue" ) && params.driver==true && params.stripeManualOnRevenus==true)?true:false, 
      moneyList:moneyList,
      totalZoneByType:false,
      money:infoMoney,
      order:"newToOld",
      viewDebugInfo:false, 
      debugInfo:{},
      driver:(params!=undefined && params.driver==true)?true:false,
      priceDriverTotal:0,
      listSimplified:[],
      name:"",
      lastName:"",
      email:(params!=undefined && params.email!=undefined)?params.email:info.companyEmail,
      viewerPartner:(params!=undefined && params.partnerID!=undefined)?true:false,
      partnerText:(params!=undefined && params.partnerText!=undefined)?params.partnerText:null,
      searchBill:{text:"", loading:false},

      extraEUMode:((params!=undefined && params.extraEUMode==true) || Platform.OS=="web")?true:false,
      partner:{id:"all",text:strings.all},
      raceStatut:"racesBilled",
      paymentMethod:{id:"all",text:strings.all},
      dateStart:Date.parse(new Date()),
      dateEnd:Date.parse(new Date()),
      partnerList:[{id:"all",text:strings.all}],
      viewSelect:(params!=undefined && params.viewSelect!=undefined)?params.viewSelect:"revenue",
      mode:"week",
      stripeConnectList:false,
      source:"all", 
      dateTxt: '',
      dataPerDay: [],
      totalZone:0,
      totalZoneOnlyValidate:0,
      dataPerDayMax: 100,
      debugRevenue:(params!=undefined && params.debugRevenue==true)?true:false, 
      totalRace:0,
      listBill:{},
      listDate:{}, 
      pickerParamsSelected:"mode",
      viewParamsWindow:false,
      withKarhoo:undefined, 
      waiting:false,
      viewSearch:false,
      viewRaceMode:"date",
      list:{},
      enableSelected:0,
      newParameters:{
        mode:"week",
        order:"newToOld",
        raceStatut:"racesBilled",
        source:{id:"all",text:strings.allSources},
        partner:{id:"all",text:strings.all},
        paymentMethod:{id:"all",text:strings.all},
      }
    };
    
    
      
      

   
  }



  findMoney(value){
    if(value==undefined) {
      if(info.countryCode=="ch") value="ch";
      else if(info.countryCode=="ma") value="ma";
      else value="eu";
    }
    var final="";
    var i;
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        console.log(moneyList[i])
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }

 getStartDay(d) {
    d = new Date(d);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
  }

  getEndDay(d) {
    d = new Date(d);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
  }

  getStartWeek(d) {
    d = new Date(d);
    var day = d.getDay();
    var diff = d.getDate() - day + (day == 0 ? -6 : 1);
    return new Date(d.getFullYear(), d.getMonth(), diff, 0, 0, 0);
  }

  getEndWeek(d) {
    d = this.getStartWeek(d);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 6, 23, 59, 59);
  }

  viewPDFFile= (link) => { 
    if(Platform.OS==="web") window.open(link, '_blank');
    else this.props.navigation.navigate("MavPDF",{mode:"viewer", url:link, title:strings.bill});
  }

 

  changeInterval(l){
    var date;
    var date2;

    if(this.state.mode=="day"){
      
      var d = new Date(this.state.dateStart);
      if(l=="before") d = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
      else if (l=="after") d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
      date=this.getStartDay(d);
      date2=this.getEndDay(d);
    }
    
    else if(this.state.mode=="week"){
      
      var d = new Date(this.state.dateStart);
      if(l=="before") d = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7);
      else if (l=="after") d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 7);
      date=this.getStartWeek(d);
      date2=this.getEndWeek(d);
      }
    else if(this.state.mode=="threeMonth"){
      
      date = new Date(this.state.dateStart);date.setDate(1);date.setHours(0);date.setMinutes(0);date.setSeconds(0);
      date.setMonth(date.getMonth()-1);
      if(l=="before") date.setMonth(date.getMonth() )
      else if (l=="after") date.setMonth(date.getMonth()+2)
      date2=new Date(date);date2.setMonth(date2.getMonth()+3)

    }
    else {
      date = new Date(this.state.dateStart);date.setDate(1);date.setHours(0);date.setMinutes(0);date.setSeconds(0);
      console.log("this "+new Date(this.state.dateStart))
      if(l=="before") date.setMonth(date.getMonth()-1)
      else if (l=="after") date.setMonth(date.getMonth()+1)
      date2=new Date(date);date2.setMonth(date2.getMonth()+1)

    }

    
    date=Date.parse(date);
    date2=Date.parse(date2);
    


    this.setState({dateStart:date,dateEnd: date2},() =>{this.updateData()})




    


  }
  removeDeferred(){
      this.alert.onAlert({title:"Identifiant ?",textInput:{text:"id"}, buttons:[{text: strings.validate,onPress: (text) => { this.findRemoveDeferred(text) }}],  });
  }

  findRemoveDeferred(id){

      get(query(ref(getDatabase(firebase), "/race"), orderByChild('deferredPaymentID'), startAt(id), endAt(id))).then(value => {
          var val=value.val();
          console.log("findRemoveDeferred "+id)
          console.log(val)
          if(val!=null){
            var list=Object.keys(val)
            var i; 
            for(i=0; i<list.length;i++){
              const fireInfo={} 
              fireInfo["/race/"+list[i]+"/deferredPaymentID"]=null
              update(ref(getDatabase(firebase)), fireInfo)
            }
          }
      })
  }

  updateData(){
    this.setState({waiting:true})
    var refData='/race'
    var orderBy="raceDate"
    console.log("this.state.source "+this.state.source)
    if(this.state.viewSelect=="revenue"){

      get(query(ref(getDatabase(firebase), refData), orderByChild(orderBy), startAt(this.state.dateStart), endAt(this.state.dateEnd))).then(snapshot => {
        var date=this.state.dateStart;
        var date2=this.state.dateEnd;
        var dateTest=Date.parse(new Date(date));
        var dayList=new Array; 
        var i=0;
        while(dateTest<date2){
          dayList[i]=0;
          dateTest+=86400000;
          i++;
        }
        var list={};
        if(snapshot.val()!=null) list=snapshot.val();
        var listArray=Object.keys(list);

        var t;
        var totalZone=0;
        var totalZoneByType={
          cbapp:0,
          onBoard:0,
          onBoardCash:0,
          onBoardCard:0,
          deferred:0,
          other:0,
        }; 
        var totalZoneOnlyValidate=0;
        var dataPerDayMax=0;
        var listFinal=new Object;
        var testStatut;
        var calPrice;  
        var priceDriverPaid,priceDriverTotal=0;  
        var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

        for (i=0;i<listArray.length;i++){
          testStatut=(list[listArray[i]].status==((this.state.raceStatut=="racesValidate" || this.state.raceStatut=="racesValBill")?"validate":"Nnn") ||   list[listArray[i]].status== ((this.state.raceStatut=="racesBilled" || this.state.raceStatut=="racesValBill" || this.state.raceStatut=="racesDeferredInvoice")?"invoiced":"Nnn")  );
          if(list[listArray[i]].status=="cancel" || list[listArray[i]].status=="remove")  testStatut=false;

          

     

          if(list[listArray[i]].charge==undefined && this.state.paymentMethod.id=="card") testStatut=false;
          else if(list[listArray[i]].cardOnBoard!=true && this.state.paymentMethod.id=="onBoardCard") testStatut=false;
          else if(info.paiementOnBoardCard==true && this.state.paymentMethod.id=="onBoard" && list[listArray[i]].cardOnBoard==true) testStatut=false;


          else if( (list[listArray[i]].deferredPayment==undefined && list[listArray[i]].karhooProvider==undefined) && this.state.paymentMethod.id=="deferred") testStatut=false;
          else if( (list[listArray[i]].deferredPayment!=undefined || list[listArray[i]].karhooProvider!=undefined || list[listArray[i]].charge!=undefined)  && this.state.paymentMethod.id=="onBoard") testStatut=false;
          


          if(testStatut==true && this.state.raceStatut=="racesDeferredInvoice" && !(list[listArray[i]].deferredPayment==true && list[listArray[i]].deferredPaymentID==undefined) ) testStatut=false;
          list[listArray[i]].id=listArray[i];
          /*je choisi la monnaie*/
          if(list[listArray[i]].moneyID==undefined) list[listArray[i]].moneyID="eu";
          if(list[listArray[i]].moneyID!=this.state.money.id) testStatut=false

          if(this.state.driver==false && (list[listArray[i]].attributedPartner==undefined || list[listArray[i]].attributedPartner.id==undefined || getAuth(firebase).currentUser.uid!=list[listArray[i]].attributedPartner.id)) testStatut=false;

          var testSource=true; 
          if(this.state.source=="karhoo" && list[listArray[i]].karhooProvider!=true) testSource=false;
          else if(this.state.source=="api" && list[listArray[i]].viaAPI!=true) testSource=false;
          else if(this.state.source=="provider" && list[listArray[i]].providerID==undefined) testSource=false;
          else if(this.state.source=="customerInApp" && (list[listArray[i]].viaAPI==true || list[listArray[i]].karhooProvider==true || list[listArray[i]].providerID!=undefined)) testSource=false;


          if(testStatut==true && testSource==true &&  ( (this.state.viewerPartner==true && (list[listArray[i]].attributedPartner!=undefined && list[listArray[i]].attributedPartner.id!=undefined &&  params.partnerID==list[listArray[i]].attributedPartner.id) ) || (this.state.viewerPartner==false && ( this.state.partner.id=="all" || (list[listArray[i]].attributedPartner!=undefined && this.state.partner.id==list[listArray[i]].attributedPartner.id) ) ))) {
            listFinal[listArray[i]]=list[listArray[i]];
            t=(list[listArray[i]].raceDate-date)/86400000; 
          t=(Math.trunc(t)+1);

         


          if(list[listArray[i]].finalPriceDriverTTC!=undefined && list[listArray[i]].comOnly==true){

            if(list[listArray[i]].charge==undefined && list[listArray[i]].chargeAfterRace===undefined){
                
                priceDriverTotal-=parseFloat(list[listArray[i]].finalPriceDriverTTC)
                
            } else priceDriverTotal+=parseFloat(list[listArray[i]].finalPrice-list[listArray[i]].finalPriceDriverTTC)

          }
          else if(list[listArray[i]].finalPriceDriverTTC!=undefined){
            
            priceDriverPaid=list[listArray[i]].finalPriceDriverTTC-list[listArray[i]].finalPrice
            
            if(list[listArray[i]].charge!=undefined ){
              if(list[listArray[i]].charge.capture==true){
                if(list[listArray[i]].charge.amount>list[listArray[i]].finalPrice) priceDriverPaid+=list[listArray[i]].finalPrice;
                else priceDriverPaid+=list[listArray[i]].charge.amount;
              }
              else {
                /*erreur sur la capture */
                priceDriverPaid+=list[listArray[i]].charge.creditAmount;
              }
            }
            else if(list[listArray[i]].alreadyPaid==true) priceDriverPaid+=list[listArray[i]].finalPrice;
            else if(list[listArray[i]].deferredPayment==true) priceDriverPaid+=list[listArray[i]].finalPrice;
            else if(list[listArray[i]].karhooProvider==true) priceDriverPaid+=list[listArray[i]].finalPrice;
            
            if(list[listArray[i]].chargeAfterRace!=undefined) priceDriverPaid+=parseFloat(list[listArray[i]].chargeAfterRace.amount);

            priceDriverTotal+=priceDriverPaid
            
          }






          if(t>0 && t<dayList.length+1) {
              if(list[listArray[i]].finalPrice!=undefined){
                
                if(this.state.hidePriceRaceForDriver==true && this.state.driver==false && list[listArray[i]].finalPriceDriverTTC!=undefined && list[listArray[i]].comOnly!=true ) calPrice=list[listArray[i]].finalPriceDriverTTC
                else calPrice=list[listArray[i]].finalPrice
              }
              else {

                calPrice=list[listArray[i]].estimatePrice

                if(list[listArray[i]].moneyID!=undefined) {
                  calPrice=calPrice.replace(this.state.money.symbole,""); 
                }
                
              }

              calPrice=parseFloat(calPrice)

              if(!(isNaN(calPrice))) {
                dayList[t]+=calPrice;
                totalZone+=calPrice;

                if(this.state.raceStatut=="racesValBill" && list[listArray[i]].status!="invoiced") totalZoneOnlyValidate+=calPrice;

                
                if(list[listArray[i]].charge!=undefined || list[listArray[i]].chargeAfterRace!=undefined) totalZoneByType.cbapp+=calPrice; 
                else if(list[listArray[i]].withMyPOS!=undefined) totalZoneByType.cbapp+=calPrice;
                else if(list[listArray[i]].deferredPayment!=undefined) totalZoneByType.deferred+=calPrice; 
                else if(list[listArray[i]].karhooProvider!=undefined) totalZoneByType.deferred+=calPrice;
                else if(list[listArray[i]].alreadyPaid!=undefined) totalZoneByType.other+=calPrice;
                else {
                    totalZoneByType.onBoard+=calPrice;
                    if(list[listArray[i]].cardOnBoard!=undefined) totalZoneByType.onBoardCard+=calPrice;
                    else totalZoneByType.onBoardCash+=calPrice;
                } 



                
              }
              
              

            
            

            if(dayList[t]>dataPerDayMax) dataPerDayMax=dayList[t]


            }
          }
      


        }
        var ord=this.state.order;

        
        var max=dataPerDayMax*1.2;
        dataPerDayMax=Math.ceil(max/50)*50;
        var list2=Object.keys( listFinal ).sort( function ( a, b ) {  return (ord==="newToOld")?listFinal[b][orderBy] - listFinal[a][orderBy]:listFinal[a][orderBy] - listFinal[b][orderBy]  } )
        if(dataPerDayMax==0) dataPerDayMax=100;



        

        var j; 
        var listSimplified=[];
        var listDate={};
        var listClient={};
        var listDriver={}; 
        var dateTest, dT,clientT;

        for(j=0; j<list2.length;j++){
          dT=new Date(listFinal[list2[j]].raceDate)
          listFinal[list2[j]].raceID=list2[j];
          if(this.state.debugRevenue==true) listFinal[list2[j]].debugMode=true;
          listFinal[list2[j]].date=((dT.getHours()<10)?"0":"")+dT.getHours()+":"+((dT.getMinutes()<10)?"0":"")+dT.getMinutes()
          listFinal[list2[j]].clientInfo=listFinal[list2[j]].clientName+" "+((listFinal[list2[j]].clientLastName!=undefined)?listFinal[list2[j]].clientLastName:"")
          if(listFinal[list2[j]].finalPriceDriverTTC==undefined || this.state.driver==true || listFinal[list2[j]].comOnly==true || this.state.hidePriceRaceForDriver==false){
              listFinal[list2[j]].priceRace=listFinal[list2[j]].estimatePrice
              listFinal[list2[j]].priceRaceExplication=(listFinal[list2[j]].withMyPOS==true)?"MyPOS":((listFinal[list2[j]].alreadyPaid==true)?strings.other.toUpperCase():((listFinal[list2[j]].karhooProvider==true)?"Karhoo" :(((listFinal[list2[j]].charge!=undefined && listFinal[list2[j]].charge.capture==true) || listFinal[list2[j]].chargeAfterRace!=undefined)?strings.cbapp:( (listFinal[list2[j]].deferredPayment==true)?((listFinal[list2[j]].deferredPaymentID==undefined)?strings.deferred:strings.deferred):(listFinal[list2[j]].withPaymentLink)? strings.linkPayment : ( (listFinal[list2[j]].cardOnBoard==true)?strings.onBoardCard:strings.onBoard))  )))
              if(this.state.debugRevenue!=true && listFinal[list2[j]].status=="invoiced" && listFinal[list2[j]].karhooProvider!=true && listFinal[list2[j]].notBill!=true  && (listFinal[list2[j]].deferredPayment!=true || listFinal[list2[j]].deferredPaymentID!=undefined)     ) listFinal[list2[j]].downloadBillLink="https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+((listFinal[list2[j]].deferredPaymentID!=undefined)?listFinal[list2[j]].deferredPaymentID:list2[j])+"%2Fbill.pdf?alt=media"
          }

          if(listFinal[list2[j]].finalPriceDriverTTC!=undefined){
              listFinal[list2[j]].priceRaceDriver=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+listFinal[list2[j]].finalPriceDriverTTC+((this.state.money.position=="right")?(this.state.money.symbole):"");
              listFinal[list2[j]].downloadDriverBillLink="https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+list2[j]+"%2F"+listFinal[list2[j]].attributedPartner.id+".pdf?alt=media"
          } 

          if( (listFinal[list2[j]].providerCommission!=undefined || listFinal[list2[j]].providerCommissionFixe!=undefined ) && listFinal[list2[j]].finalPrice!=undefined && this.state.driver==true) listFinal[list2[j]].priceRaceProvider=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+ ( (Math.round( (listFinal[list2[j]].finalPrice * (  ( (listFinal[list2[j]].providerCommission!=undefined)?listFinal[list2[j]].providerCommission:0 ) /100)) *100)/100)  + ((listFinal[list2[j]].providerCommissionFixe!=undefined)?listFinal[list2[j]].providerCommissionFixe:0 ) )  +((this.state.money.position=="right")?(this.state.money.symbole):"")


          /*Affichage par date*/
          dateTest=new Date(listFinal[list2[j]].raceDate);
          dateTest=dateTest.getDate()+""+dateTest.getMonth();
          if(listDate[dateTest]==undefined) listDate[dateTest]={name: strings.dayListComplete[(dT.getDay()==0)?6:(dT.getDay()-1)]+" "+ dT.getDate()+" "+strings.monthList[dT.getMonth()] , list:[]};
          listDate[dateTest].list.push(listFinal[list2[j]])


          var words = listFinal[list2[j]].racePlaceStartName.split(',');
          var wordsI;
          var racePlaceStartList=[];
          var racePlaceEndList=[];       
          for(wordsI=0;wordsI<3; wordsI++){
            if(words[wordsI]!=undefined && words[wordsI]!="" && words[wordsI]!=" ") racePlaceStartList.push(words[wordsI].trim())
          }
          listFinal[list2[j]].racePlaceStartList=racePlaceStartList;
          if(listFinal[list2[j]].racePlaceEndName!=undefined && listFinal[list2[j]].racePlaceEndName!=""){
            words = listFinal[list2[j]].racePlaceEndName.split(',');
            for(wordsI=0;wordsI<3; wordsI++){
              if(words[wordsI]!=undefined && words[wordsI]!="" && words[wordsI]!=" ") racePlaceEndList.push(words[wordsI].trim())
            }           
            listFinal[list2[j]].racePlaceEndList=racePlaceEndList;
          }

          listSimplified.push(listFinal[list2[j]])



          /* Affichage par chauffeur */
          if(listFinal[list2[j]].attributedPartner!=undefined){
            listFinal[list2[j]].date= dT.getDate()+" "+strings.monthList[dT.getMonth()] +" - "+ ((dT.getHours()<10)?"0":"")+dT.getHours()+":"+((dT.getMinutes()<10)?"0":"")+dT.getMinutes()

            if(listDriver[listFinal[list2[j]].attributedPartner.id]==undefined) listDriver[listFinal[list2[j]].attributedPartner.id]={name: listFinal[list2[j]].attributedPartner.text , list:[]};
            listDriver[listFinal[list2[j]].attributedPartner.id].list.push(listFinal[list2[j]])
          }

          /*Affichage par client*/
          if(listFinal[list2[j]].clientID!=undefined) clientT=listFinal[list2[j]].clientID
          else {
            clientT=(listFinal[list2[j]].clientName!=undefined)?listFinal[list2[j]].clientName.replace(/ /g,'').toLowerCase():""; 
            clientT+=(listFinal[list2[j]].clientLastName!=undefined)?listFinal[list2[j]].clientLastName.replace(/ /g,'').toLowerCase():""; 
          }

          listFinal[list2[j]].date= dT.getDate()+" "+strings.monthList[dT.getMonth()] +" - "+ ((dT.getHours()<10)?"0":"")+dT.getHours()+":"+((dT.getMinutes()<10)?"0":"")+dT.getMinutes()
          if(listClient[clientT]==undefined) listClient[clientT]={name: ((listFinal[list2[j]].clientName!=undefined)?listFinal[list2[j]].clientName:"")+ ((listFinal[list2[j]].clientLastName!=undefined && listFinal[list2[j]].clientName!=undefined)?" ":"") + ((listFinal[list2[j]].clientLastName!=undefined)?listFinal[list2[j]].clientLastName:"") , list:[]};
          listClient[clientT].list.push(listFinal[list2[j]])


          if(listFinal[list2[j]].providerID!=undefined){

            if(listClient[listFinal[list2[j]].providerID]==undefined) listClient[listFinal[list2[j]].providerID]={provider:true,  name: (listFinal[list2[j]].providerEnterprise!=undefined)? listFinal[list2[j]].providerEnterprise :  (    ((listFinal[list2[j]].providerName!=undefined)?listFinal[list2[j]].providerName:"")+ ((listFinal[list2[j]].providerLastName!=undefined && listFinal[list2[j]].providerName!=undefined)?" ":"") + ((listFinal[list2[j]].providerLastName!=undefined)?listFinal[list2[j]].providerLastName:"")) , list:[]};
            listClient[listFinal[list2[j]].providerID].list.push(listFinal[list2[j]])


          }
          


        } 

        console.log("totalZoneByType")
        console.log(totalZoneByType)
        if(totalZoneByType.cbapp ==0) delete totalZoneByType.cbapp
        else totalZoneByType.cbapp=totalZoneByType.cbapp.toFixed(2)
        if(totalZoneByType.onBoard ==0) delete totalZoneByType.onBoard
        else totalZoneByType.onBoard=totalZoneByType.onBoard.toFixed(2)
        if(totalZoneByType.onBoardCash ==0) delete totalZoneByType.onBoardCash
        else totalZoneByType.onBoardCash=totalZoneByType.onBoardCash.toFixed(2)
        if(totalZoneByType.onBoardCard ==0) delete totalZoneByType.onBoardCard
        else totalZoneByType.onBoardCard=totalZoneByType.onBoardCard.toFixed(2)
        if(totalZoneByType.deferred ==0) delete totalZoneByType.deferred
        else totalZoneByType.deferred=totalZoneByType.deferred.toFixed(2)
          if(totalZoneByType.other ==0) delete totalZoneByType.other
        else totalZoneByType.other=totalZoneByType.other.toFixed(2)

        if(totalZoneByType.onBoard!=undefined && totalZoneByType.onBoardCash!=undefined && totalZoneByType.onBoard==totalZoneByType.onBoardCash){
            if(totalZoneByType.onBoardCard!=undefined) delete totalZoneByType.onBoard
            else delete totalZoneByType.onBoardCash
        } 
        if(totalZoneByType.onBoard!=undefined && totalZoneByType.onBoardCard!=undefined && totalZoneByType.onBoard==totalZoneByType.onBoardCard) delete totalZoneByType.onBoard
        if(totalZoneByType.onBoardCard!=undefined && totalZoneByType.onBoardCash!=undefined) delete totalZoneByType.onBoard


        if(Object.keys(totalZoneByType).length==0)  totalZoneByType=false;


        this.setState({waiting:false,listSimplified:listSimplified,listBill:listFinal,totalZoneByType:totalZoneByType, listClient:listClient, listDate:listDate,listDriver:listDriver, priceDriverTotal:priceDriverTotal.toFixed(2),dataPerDay:dayList,totalRace:Object.keys(listFinal).length,totalZone:Math.round(totalZone*100)/100,totalZoneOnlyValidate:Math.round(totalZoneOnlyValidate*100)/100, dataPerDayMax:dataPerDayMax})


      });

    }
    else {
      get(query(ref(getDatabase(firebase), refData), orderByChild(orderBy), startAt(this.state.dateStart), endAt(this.state.dateEnd))).then(snapshot => {
        var val=snapshot.val();

        var client={};
        if(val!=null){
          var ord=this.state.order;
            var list=Object.keys( val ).sort( function ( a, b ) {  return (ord==="newToOld")?val[b][orderBy] - val[a][orderBy]:val[a][orderBy] - val[b][orderBy]  } )
            var i; 
            var dataProv;
            for(i=0;i<list.length;i++){

              if((val[list[i]].deferredPayment==true && val[list[i]].deferredPaymentID==undefined &&  val[list[i]].status=="invoiced" ) || (val[list[i]].karhooProvider==true && val[list[i]].deferredPaymentID==undefined && true && (val[list[i]].status=="cancel" && val[list[i]].attributedPartner!=undefined &&    val[list[i]].cancelRaceDate!=undefined && val[list[i]].raceDate!=undefined && val[list[i]].cancelRaceDate>(val[list[i]].raceDate-1000*60*60) ) ) ){
                  val[list[i]].raceID=list[i]
                  val[list[i]].clientText=(val[list[i]].karhooProvider==true)?"Karhoo":( (val[list[i]].clientEntreprise!=undefined)?val[list[i]].clientEntreprise:(val[list[i]].clientName+((val[list[i]].clientLastName!=undefined && val[list[i]].clientLastName!="" && val[list[i]].clientName!=undefined && val[list[i]].clientName!="")?" ":"")+val[list[i]].clientLastName))
                  val[list[i]].enable=false

                  if(val[list[i]].moneyID==undefined) val[list[i]].moneyID="eu";
                  if(val[list[i]].moneyID==this.state.money.id){
                      if(val[list[i]].clientID!=undefined){
                        if( client[val[list[i]].clientID]==undefined){
                          client[val[list[i]].clientID]={name:(val[list[i]].customerProName!=undefined)?(val[list[i]].customerProEnterprise!=undefined)?val[list[i]].customerProEnterprise:(val[list[i]].customerProName+((val[list[i]].customerProLastName!=undefined && val[list[i]].customerProLastName!="" && val[list[i]].customerProName!=undefined && val[list[i]].customerProName!="")?" ":"")+val[list[i]].customerProLastName):((val[list[i]].clientEnterprise!=undefined)?val[list[i]].clientEnterprise:(val[list[i]].clientName+((val[list[i]].clientLastName!=undefined && val[list[i]].clientLastName!="" && val[list[i]].clientName!=undefined && val[list[i]].clientName!="")?" ":"")+val[list[i]].clientLastName)) ,raceList:[], clientType:(val[list[i]].customerProName)?"customerPro":"customer", enableCounter:0} 
                        
                        }

                        


                        var driverText=(val[list[i]].attributedPartner!=undefined) ?val[list[i]].attributedPartner.text:""
                        val[list[i]].driverText=driverText
                        dataProv=val[list[i]]
                        dataProv.id=list[i];
                        client[val[list[i]].clientID].raceList.push(dataProv)
                        
                      }
                      else if(val[list[i]].providerID!=undefined){

                        if( client[val[list[i]].providerID]==undefined){client[val[list[i]].providerID]={name:val[list[i]].providerName+" "+val[list[i]].providerLastName ,raceList:[], clientType:"provider", enableCounter:0} }
                        var driverText=(val[list[i]].attributedPartner!=undefined) ?val[list[i]].attributedPartner.text:""
                        val[list[i]].driverText=driverText
                        dataProv=val[list[i]]
                        dataProv.id=list[i];
                        client[val[list[i]].providerID].raceList.push(dataProv)
                        
                      } else if(val[list[i]].karhooProvider!=undefined){

                        if( client["karhoo"]==undefined){client["karhoo"]={name:"Karhoo" ,raceList:[], clientType:"karhoo", enableCounter:0}  }
                        var driverText=(val[list[i]].attributedPartner!=undefined) ?val[list[i]].attributedPartner.text:""
                        val[list[i]].driverText=driverText
                        dataProv=val[list[i]]
                        dataProv.id=list[i];
                        client["karhoo"].raceList.push(dataProv)

                      }



                  }
                }





          }




        }

        console.log("la liste ")
        console.log(client)

        this.setState({list:client,waiting:false})

      })

    }

    

  }


  sendByMail(){
    const style=styleInfo();
                var listTxt="<html xmlns=\'http://www.w3.org/1999/xhtml\' xmlns:v=\'urn:schemas-microsoft-com:vml\' xmlns:o=\'urn:schemas-microsoft-com:office:office\'><head>  <title></title>  <!--[if !mso]><!-- -->  <meta http-equiv=\'X-UA-Compatible\' content=\'IE=edge\'>  <!--<![endif]--><meta http-equiv=\'Content-Type\' content=\'text/html; charset=UTF-8\'><meta name=\'viewport\' content=\'width=device-width, initial-scale=1.0\'><style type=\'text/css\'>  #outlook a { padding: 0; }  .ReadMsgBody { width: 100%; }  .ExternalClass { width: 100%; }  .ExternalClass * { line-height:100%; }  body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }  table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }  p { display: block; margin: 13px 0; }      </style><!--[if !mso]><!--><style type=\'text/css\'>  @media only screen and (max-width:480px) {    @-ms-viewport { width:320px; }    @viewport { width:320px; }  }</style><!--<![endif]--><!--[if mso]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--><!--[if lte mso 11]><style type=\'text/css\'>  .outlook-group-fix {    width:100% !important;  }</style><![endif]--><style type=\'text/css\'>  @media only screen and (min-width:480px) {    .mj-column-per-100 { width:100%!important; }  }</style></head><body style=\'background: #efefefef;\'>    <div class=\'mj-container\' style=\'background-color:#efefefef;\'> <div style=\'margin:0px auto;max-width:600px;background:"+style.color1+";\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:"+style.color1+";\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><h1 style=\'font-family: Helvetica, sans-serif; color: #FFFFFF; font-size: 26px; line-height: 100%;\'>RELEVÉ DES FACTURES</h1></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:#FFFFFF;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>Relevé d'activité pour la période du "+(new Date(this.state.dateStart).getDate() < 10 ? '0' : '') +new Date(this.state.dateStart).getDate() +'/' +(new Date(this.state.dateStart).getMonth() + 1 < 10? '0': '') + (new Date(this.state.dateStart).getMonth() + 1)+" au "+(new Date(this.state.dateEnd).getDate() < 10 ? '0' : '') +new Date(this.state.dateEnd).getDate() +'/' +(new Date(this.state.dateEnd).getMonth() + 1 < 10 ? '0' : '') +(new Date(this.state.dateEnd).getMonth() + 1)+"</br>Cette liste a été édité le : "+(new Date().getDate() < 10 ? '0' : '') +new Date().getDate() +'/' +(new Date().getMonth() + 1 < 10? '0': '') +(new Date().getMonth() + 1)+"/"+new Date().getFullYear()+" à "+(new Date().getHours() < 10 ? '0' : '') +new Date().getHours() +':' +(new Date().getMinutes() < 10? '0': '') +(new Date().getMinutes() )+" </p></div><tr><td style=\'word-wrap:break-word;font-size:0px;padding:10px 25px;padding-top:17px;padding-bottom:17px;padding-right:30px;padding-left:30px;\'><p style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\'></p><!--[if mso | IE]><table role=\'presentation\' align=\'center\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\' width=\'600\'><tr><td style=\'height:0;line-height:0;\'>&nbsp;</td></tr></table><![endif]--></td></tr><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'left\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:left;\'>"
                listTxt+="<p style='text-align: center; font-weight: bold;'>FACTURES CLIENTS</p>"
                listTxt+="<table style='margin:0px auto;width:100%;' ><thead style=' line-height:30px; background:"+style.color1+"; color:#ffffff; '><tr style='line-height:30px;text-align:center; border: 1px solid rgb(190,190,190);'><th>Date</th><th>Status</th><th>n°</th><th>Clients<br>et chauffeurs</th><th>Montant HT</th><th>TVA</th><th>Montant TTC</th></tr></thead><tbody>"

                var list=Object.keys(this.state.listBill);
                var i;
                var finalPrice=0;
                var finalPriceHT=0;
                var finalTVA=0;

                var billDriver={}; 
                var infoProvider={};


                for (i=0;i<list.length;i++){

                  if(this.state.listBill[list[i]].status=="invoiced"){
                      
                      var billNumber=this.state.listBill[list[i]].billNumber; 
                      if(this.state.listBill[list[i]].billNumber==undefined && this.state.listBill[list[i]].billNumberDriver!=undefined) billNumber=this.state.listBill[list[i]].billNumberDriver; 

                      if(this.state.listBill[list[i]].deferredPayment==true && this.state.listBill[list[i]].deferredPaymentID==undefined && (this.state.driver==true || this.state.hidePriceRaceForDriver==false) ) listTxt+="<tr style=' line-height:30px; text-align:center; '><td style='border: 1px solid rgb(190,190,190);'>"+(new Date(this.state.listBill[list[i]].raceDate).getDate() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getDate() +'/' +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1 < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1)+" - "+(new Date(this.state.listBill[list[i]].raceDate).getHours() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getHours() +':' +(new Date(this.state.listBill[list[i]].raceDate).getMinutes() < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMinutes()) +"</td><td style='border: 1px solid rgb(190,190,190);'>En attente</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].billNumber!=undefined)?this.state.listBill[list[i]].billNumber:"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+this.state.listBill[list[i]].clientName+" "+this.state.listBill[list[i]].clientLastName+"<br>"+((this.state.listBill[list[i]].attributedPartner!=undefined)?this.state.listBill[list[i]].attributedPartner.text:"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].finalPriceHT!=undefined)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.listBill[list[i]].finalPriceHT+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].finalPriceHT!=undefined)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(this.state.listBill[list[i]].finalPrice-this.state.listBill[list[i]].finalPriceHT).toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>   "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.listBill[list[i]].finalPrice+((this.state.money.position=="right")?(this.state.money.symbole):"")+"    </td></tr>"
                      else if(this.state.listBill[list[i]].finalPriceDriverTTC==undefined || this.state.driver==true || this.state.hidePriceRaceForDriver==false) {
                          /*facture client*/

                        listTxt+="<tr style=' line-height:30px; text-align:center; '><td style='border: 1px solid rgb(190,190,190);'><a style='color:"+style.color1+"' href='https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+((this.state.listBill[list[i]].deferredPaymentID!=undefined)?this.state.listBill[list[i]].deferredPaymentID:list[i])+"%2Fbill.pdf?alt=media"+"'>"+(new Date(this.state.listBill[list[i]].raceDate).getDate() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getDate() +'/' +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1 < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1)+" - "+(new Date(this.state.listBill[list[i]].raceDate).getHours() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getHours() +':' +(new Date(this.state.listBill[list[i]].raceDate).getMinutes() < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMinutes()) +"</td><td style='border: 1px solid rgb(190,190,190);'>Editée</td><td style='border: 1px solid rgb(190,190,190);'>"+((billNumber!=undefined)?billNumber:"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+this.state.listBill[list[i]].clientName+" "+this.state.listBill[list[i]].clientLastName+"<br>"+((this.state.listBill[list[i]].attributedPartner!=undefined)?this.state.listBill[list[i]].attributedPartner.text:"--") +"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].finalPriceHT!=undefined)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.listBill[list[i]].finalPriceHT+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].finalPriceHT!=undefined)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(this.state.listBill[list[i]].finalPrice-this.state.listBill[list[i]].finalPriceHT).toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>   "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.listBill[list[i]].finalPrice+((this.state.money.position=="right")?(this.state.money.symbole):"")     +"    </td></tr>"

                      }

                      if(this.state.listBill[list[i]].providerID!=undefined && this.state.listBill[list[i]].providerBill!=true && (( this.state.listBill[list[i]].providerCommission!=undefined && this.state.listBill[list[i]].providerCommission>0) || ( this.state.listBill[list[i]].providerCommissionFixe!=undefined && this.state.listBill[list[i]].providerCommissionFixe>0) )    )   {
                       
                        

                        if(infoProvider[this.state.listBill[list[i]].providerID]==undefined){
                            infoProvider[this.state.listBill[list[i]].providerID]={
                              text:(this.state.listBill[list[i]].providerEnterprise!=undefined)?this.state.listBill[list[i]].providerEnterprise:(this.state.listBill[list[i]].providerName+" "+this.state.listBill[list[i]].providerLastName),
                              give:0,
                            }
                        }
                        
                        if( this.state.listBill[list[i]].providerCommission!=undefined && this.state.listBill[list[i]].providerCommission>0) infoProvider[this.state.listBill[list[i]].providerID].give+=(Math.round( (this.state.listBill[list[i]].finalPrice * (this.state.listBill[list[i]].providerCommission/100)) *100)/100);
                        if( this.state.listBill[list[i]].providerCommissionFixe!=undefined && this.state.listBill[list[i]].providerCommissionFixe>0) infoProvider[this.state.listBill[list[i]].providerID].give+=this.state.listBill[list[i]].providerCommissionFixe


                      }



                      if(this.state.listBill[list[i]].finalPriceDriverTTC!=undefined){

                        var give=this.state.listBill[list[i]].finalPriceDriverTTC-this.state.listBill[list[i]].finalPrice;
                        if(this.state.listBill[list[i]].charge!=undefined ){
                          if(this.state.listBill[list[i]].charge.capture==true){
                            if(this.state.listBill[list[i]].charge.amount>this.state.listBill[list[i]].finalPrice) give+=this.state.listBill[list[i]].finalPrice;
                            else give+=this.state.listBill[list[i]].charge.amount;
                          }else give+=this.state.listBill[list[i]].charge.creditAmount;
                        }
                        else if(this.state.listBill[list[i]].alreadyPaid==true) give+=this.state.listBill[list[i]].finalPrice;
                        else if(this.state.listBill[list[i]].deferredPayment==true) give+=this.state.listBill[list[i]].finalPrice;
                        else if(this.state.listBill[list[i]].karhooProvider==true) give+=this.state.listBill[list[i]].finalPrice;


                        if(billDriver[this.state.listBill[list[i]].attributedPartner.id]==undefined){
                            billDriver[this.state.listBill[list[i]].attributedPartner.id]={
                              text:this.state.listBill[list[i]].attributedPartner.text,
                              finalPrice:0,
                              give:0,
                              list:{},
                            }
                        }
                        billDriver[this.state.listBill[list[i]].attributedPartner.id].list[list[i]]={
                          raceID:list[i],
                          raceDate:(new Date(this.state.listBill[list[i]].raceDate).getDate() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getDate() +'/' +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1 < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1)+" - "+(new Date(this.state.listBill[list[i]].raceDate).getHours() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getHours() +':' +(new Date(this.state.listBill[list[i]].raceDate).getMinutes() < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMinutes()),
                          finalPriceDriverTTC:this.state.listBill[list[i]].finalPriceDriverTTC,
                          give:give,
                          billNumber:((this.state.listBill[list[i]].billNumberDriver!=undefined)?this.state.listBill[list[i]].billNumberDriver:"--"),
                        }
                        billDriver[this.state.listBill[list[i]].attributedPartner.id].finalPrice+=parseFloat(this.state.listBill[list[i]].finalPriceDriverTTC);
                        billDriver[this.state.listBill[list[i]].attributedPartner.id].give+=billDriver[this.state.listBill[list[i]].attributedPartner.id].list[list[i]].give

                        



                      }


                      if(this.state.listBill[list[i]].finalPriceDriverTTC==undefined || this.state.driver==true || this.state.hidePriceRaceForDriver==false){
                        finalPrice+=this.state.listBill[list[i]].finalPrice;

                        if(finalPriceHT!==false && this.state.listBill[list[i]].finalPriceHT!=undefined ){
                            finalPriceHT+=parseFloat(this.state.listBill[list[i]].finalPriceHT)
                            finalTVA+=(parseFloat(this.state.listBill[list[i]].finalPrice)-parseFloat(this.state.listBill[list[i]].finalPriceHT))

                        }
                        else finalPriceHT=false;
                      }

                  }
                  else if(this.state.listBill[list[i]].status=="validate" && (this.state.driver==true || this.state.hidePriceRaceForDriver==false)) listTxt+="<tr style=' line-height:30px; text-align:center; '><td style='border: 1px solid rgb(190,190,190);'>"+(new Date(this.state.listBill[list[i]].raceDate).getDate() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getDate() +'/' +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1 < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMonth() + 1)+" - "+(new Date(this.state.listBill[list[i]].raceDate).getHours() < 10 ? '0' : '') +new Date(this.state.listBill[list[i]].raceDate).getHours() +':' +(new Date(this.state.listBill[list[i]].raceDate).getMinutes() < 10? '0': '') +(new Date(this.state.listBill[list[i]].raceDate).getMinutes()) +"</td><td style='border: 1px solid rgb(190,190,190);'>Non éditée</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.listBill[list[i]].billNumber!=undefined)?this.state.listBill[list[i]].billNumber:"--")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+"--"+"</td><td style='border: 1px solid rgb(190,190,190);'>"+"--"+"</td><td style='border: 1px solid rgb(190,190,190);'>   ("+this.state.listBill[list[i]].estimatePrice+")    </td></tr>"


                }
                

                



                listTxt+="<tr style='line-height:10px;'><td colspan='4'>&nbsp;</td></tr></tbody><tfoot><tr><td colspan='4'></td><td colspan='2'   style='text-align: right; line-height:30px; font-weight: bold;' >Total HT</td><td style='text-align: center;'>"+((finalPriceHT!=false)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+finalPriceHT.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td></tr><tr><td colspan='4'></td><td colspan='2'   style='text-align: right; line-height:30px; font-weight: bold;' >TVA</td><td style='text-align: center;'>"+((finalPriceHT!=false)?(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+finalTVA.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")):"--")+"</td></tr><tr><td colspan='4'></td><td colspan='2'   style='text-align: right; line-height:30px; color:"+style.color1+"; font-weight: bold;' >Total TTC</td><td style='text-align: center; color:"+style.color1+"; font-weight: bold;'>"+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+finalPrice.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td></tr></tfoot></table>"

                var billDriverList=Object.keys(billDriver);
                for(i=0;i<billDriverList.length;i++){
                  var drinfo=billDriver[billDriverList[i]];
                  listTxt+="<p style='font-size:1px;margin:15px auto;border-top:1px dotted #929292;width:100%;'></p><p style='text-align: center; font-weight: bold;'>FACTURES DE "+drinfo.text.toUpperCase()+"</p>"


                  listTxt+="<table style='margin:0px auto;width:100%;' ><thead style=' line-height:30px; background:"+style.color1+"; color:#ffffff; '><tr style='line-height:30px;text-align:center; border: 1px solid rgb(190,190,190);'><th>Date</th><th>n°</th><th>Montant</th><th>Dû par l'appli</th></tr></thead><tbody>"

                  var drinfoList=Object.keys(drinfo.list)
                  var j;
                  for(j=0;j<drinfoList.length;j++){
                    
                      listTxt+="<tr style=' line-height:30px; text-align:center; '><td style='border: 1px solid rgb(190,190,190);'><a style='color:"+style.color1+"'href='https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+drinfoList[j]+"%2F"+billDriverList[i]+".pdf?alt=media"+"'>"+drinfo.list[drinfoList[j]].raceDate+"</a></td><td style='border: 1px solid rgb(190,190,190);'>"+drinfo.list[drinfoList[j]].billNumber+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+drinfo.list[drinfoList[j]].finalPriceDriverTTC+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+drinfo.list[drinfoList[j]].give.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td></tr>"

                  }




                  listTxt+="<tr style='line-height:10px;'><td colspan='4'>&nbsp;</td></tr></tbody><tfoot><tr><td colspan='1'></td><td colspan='2'   style='text-align: right; line-height:30px; font-weight: bold;' >Total</td><td style='text-align: center;'>"+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+drinfo.finalPrice.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td></tr><tr><td colspan='1'></td><td colspan='2'   style='text-align: right; line-height:30px; color:"+style.color1+"; font-weight: bold;' >Dû par l'appli</td><td style='text-align: center; color:"+style.color1+"; font-weight: bold;'>"+ ((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+drinfo.give.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td></tr></tfoot></table>"


                }

                var infoProviderList=Object.keys(infoProvider);
                if(infoProviderList.length>0) {
                  listTxt+="<p style='font-size:1px;margin:15px auto;border-top:1px dotted #929292;width:100%;'></p><p style='text-align: center; font-weight: bold;'>APPORTEURS D'AFFAIRES "+"</p>"
                  listTxt+="<table style='margin:0px auto;width:100%;' ><thead style=' line-height:30px; background:"+style.color1+"; color:#ffffff; '><tr style='line-height:30px;text-align:center; border: 1px solid rgb(190,190,190);'><th>Nom</th><th>Dû par l'appli</th></tr></thead><tbody>"

                  for(i=0;i<infoProviderList.length;i++){
                      listTxt+="<tr style=' line-height:30px; text-align:center; '><td style='border: 1px solid rgb(190,190,190);'>"+infoProvider[infoProviderList[i]].text+"</td><td style='border: 1px solid rgb(190,190,190);'>"+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(Math.round( infoProvider[infoProviderList[i]].give *100)/100)+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</td></tr>"

                  }
                }


                

                /*Pour le reste*/
                listTxt+="</div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr>  </tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:11px;line-height:22px;text-align:center;\'><p><span style=\'color:#ffffff;\'>"+info.companyBrand+" | "+info.companyAdress+" | "+info.companyCity+" | "+info.companyPhone+" | "+info.companyEmail+"</span></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--></div></body></html>"
                
                getAuth(firebase).currentUser.getIdToken().then(token => {
                  
                  
                  var bodyInfo={
                        toEmail:this.state.email,
                        toName:info.companyBrand, 
                        subject: "Relevé des factures", 
                        HTMLPart:listTxt, 
                        replyToEmail:info.mavEmail,
                        replyToName:info.companyBrand,
                        token:token,
                        fromEmail:info.mavEmail,
                        fromName:info.companyBrand,
                        userID:getAuth(firebase).currentUser.uid,

                    }



                  console.log(bodyInfo)

                  fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendByMail", {
                    body: JSON.stringify(bodyInfo),
                    method: "POST"}).then((response) => response.text()).then((responseJson) => {
                      console.log("response")
                      console.log(responseJson)
                    })

                    
  
                })

                
              
              
              this.alert.onAlert({title:strings.messageSendYou}); 
  }




  generateBills(withLink){
    if(this.state.waiting!=true){


        this.setState({waiting:true})
        var listArray=Object.keys(this.state.list);
        var i,j;

        for(i=0;i<listArray.length;i++){
          var customerID=listArray[i];

          var raceList=[];

          for(j=0;j<this.state.list[listArray[i]].raceList.length;j++){

            if(this.state.list[listArray[i]].raceList[j].enable==true){
              raceList.push(this.state.list[listArray[i]].raceList[j])
            }
          }
          if(raceList.length>0){
            var uuid=generateUUID();
            console.log("uuid de la course = "+uuid)
            /*partnerID à ajouter pour que ça se passe bien*/
            
            var sendToFB={customerID:customerID,raceList:raceList}; 

            if(this.state.billWithoutDetail==true) sendToFB.billWithoutDetail=true;


            if(withLink==true) {
              sendToFB.withPaymentLink=true;
              sendToFB.stripePublicKey=info.stripePublicKey;
              sendToFB.currency=this.state.money.stripeCode

            }
            
            const fireInfo={} 
            fireInfo['generateDeferredInvoiceBill/' +uuid]=sendToFB
            update(ref(getDatabase(firebase)), fireInfo)

            console.log(sendToFB)
            


            timer.setTimeout("timer", () => {
              this.setState({waiting:false,raceStatut:"racesBilled",enableSelected:0},() =>{this.changeInterval()})
              this.alert.onAlert({title:strings.billEnd});
            }, 6000);
          }
        }
      }
  }


  _viewTransfert= () => {
        
        if(this.state.stripeConnectList==false){
            /*je vais récupérer les chauffeurs connectés */
            get(child(ref(getDatabase(firebase)), '/stripeConnect')).then(value => {
                  var val=value.val();
                  if(val!=null){
                      this.setState({stripeConnectList:val },() =>{this._viewTransfert()})
                  }
                  else {
                    this.setState({stripeConnectList:{} }); 
                    this.alert.onAlert({title:strings.transferToDriverNoDriver, subTitle:strings.transferMoreInfo}); 

                  }

            })
        }
        else if(this.state.stripeConnectList=={}) this.alert.onAlert({title:strings.transferToDriverNoDriver, subTitle:strings.transferMoreInfo});
        else {
            /*je fais la correspondance */
            var i;
            var item=[];
            for(i=0; i<this.state.partnerList.length;i++){
              if(this.state.stripeConnectList[this.state.partnerList[i].id]!=undefined) item.push({text:this.state.partnerList[i].text,id:this.state.partnerList[i].id })
            }

            this.alert.onAlert({title:strings.transferToDriver, subTitle:strings.transferToDriverMoney, help:{title:strings.transferToDriver, subTitle:strings.transferMoreInfo},  items:item, buttons:[{text: strings.validate,onPress: (id,value) => { 
                  


                  this.alert.onAlert({title:strings.amountTransfert,textInput:{placeholder:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"40"+((this.state.money.position=="right")?(this.state.money.symbole):""),text:"",sizeMultiplicator:2,detectSequencePosition:this.state.money.position,detectSequence:this.state.money.symbole,keyboardType:"numeric"},buttons:[
                    {text: strings.validate,onPress: (value) => {
                      var estg=value.toString().replace(this.state.money.symbole,'')
                      estg=parseFloat(estg);
                      if(!isNaN(estg) ){

                        this.alert.onAlert({title:strings.thankWaiting, waiting:true}); 
                        
                        getAuth(firebase).currentUser.getIdToken().then(token => {

                            var bodyInfo={
                                amount:(estg*100),
                                account:this.state.stripeConnectList[item[id].id].stripeAccount,
                                token:token,
                                userID:getAuth(firebase).currentUser.uid,

                            }

                            fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/stripeConnect/transfer/", {body: JSON.stringify(bodyInfo),method: "POST"}).then((response) => response.json()).then((responseJson) => {
                                
                                if(responseJson.error==true){
                                  if(responseJson.errorCode==1) this.alert.onAlert({title:strings.transferToDriverError});
                                  else this.alert.onAlert({title:strings.errorDefault});
                                }
                                else {
                                  this.alert.onAlert({title:strings.transferOK});
                                }

                            })

                          })

                      }
                      else this.alert.onAlert({title:strings.errorDefault});
                    }},
                    {text: strings.cancel, style:"cancel",onPress: () => {}}
                    ],})




             }},{text: strings.cancel, style:"cancel",onPress: () => {}}] });
          
      

      
        } 
        
      




  }


  _filterMoney = () => {

      var list=[];
      var selected=-1;
      var i;

      for(i=0;i<moneyList.length;i++){
          if(this.state.money==moneyList[i]) selected=i;
          list.push({text:moneyList[i][strings.idLangue]+" ("+moneyList[i].symbole+")",icon:moneyList[i].flag,image:moneyList[i].flag})
      }
                            

      this.alert.onAlert({title:strings.moneySelected, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
        this.setState({money:moneyList[id]},() =>{this.updateData(); if(Platform.OS!="web" && (this.state.extraEUMode==true) ) this.props.navigation.setOptions({ headerRight: props => <HeaderRight info={ {filterMoney:this._filterMoney, disableSearch:(this.state.viewSelect=="waitBill")?true:false, moneySymbole:moneyList[id].symbole,viewSearch:this.state.viewSearch, stripeManualOnRevenus:this.state.stripeManualOnRevenus, transfertRevenu:this._viewTransfert, changeViewSearch:this._viewSearch } }   {...props} /> })  } )  
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }

  viewTotalZoneByType= () => {

    var res=[]; 

        if(this.state.totalZoneByType.cbapp!=undefined) res.push({text:strings.cbapp,textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.cbapp+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/paymentCard.png"),icon:require("../assets/paymentCard.png") })
        if(this.state.totalZoneByType.onBoard!=undefined) res.push({text:strings.onBoard,textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.onBoard+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/paymentOnBoard.png"),icon:require("../assets/paymentOnBoard.png") })
        if(this.state.totalZoneByType.onBoardCash!=undefined) res.push({text:strings.onBoardCash,textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.onBoardCash+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/paymentCash.png"),icon:require("../assets/paymentCash.png") })
        if(this.state.totalZoneByType.onBoardCard!=undefined) res.push({text:strings.onBoardCard,textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.onBoardCard+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/pos-terminal.png"),icon:require("../assets/pos-terminal.png") })
        if(this.state.totalZoneByType.deferred!=undefined) res.push({text:strings.deferred,textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.deferred+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/paymentTransfer.png"),icon:require("../assets/paymentTransfer.png") })
        if(this.state.totalZoneByType.other!=undefined) res.push({text:(Platform.OS=="web")?strings.otherPaiment:strings.other,textSmall:'("'+strings.raceAlreadyPaid+'")', textRight:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneByType.other+((this.state.money.position=="right")?(this.state.money.symbole):""), image:require("../assets/paymentTransfer.png"),icon:require("../assets/paymentTransfer.png") })



        this.alert.onAlert({title:strings.payment, items:res ,notSelectable:true});


  }


  _viewSearch = () => {
    this.setState({viewSearch:!this.state.viewSearch},() =>{

      if(Platform.OS!="web") this.props.navigation.setOptions({ headerRight: props => <HeaderRight  info={ {filterMoney:this._filterMoney, disableSearch:(this.state.viewSelect=="waitBill")?true:false,moneySymbole:(this.state.extraEUMode==true)?this.state.money.symbole:undefined, stripeManualOnRevenus:this.state.stripeManualOnRevenus, transfertRevenu:this._viewTransfert, viewSearch:this.state.viewSearch, changeViewSearch:this._viewSearch } }   {...props} /> })
    })


  }

  viewByMode= () => {
      var selected=-1;
      var i;
      var list=[{"id":"day","text":strings.day},{"id":"week","text":strings.week},{"id":"month","text":strings.month}, {"id":"threeMonth","text":"3 "+strings.month}]
      for(i=0;i<list.length;i++){
          if(this.state.newParameters.mode==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.viewBy, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.mode=list[id].id; this.setState({newParameters:np}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }

  viewSwitchView= () => {
      var selected=-1;
      var i;
      var list=[{"id":"revenue","text":strings.revenue},{"id":"waitBill","text":strings.billWaiting}]
      for(i=0;i<list.length;i++){
          if(this.state.viewSelect==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.viewBy, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {this.setState(() => ({viewSelect:list[id].id }),function(){ this.changeInterval(); }) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }

  viewByOrder= () => {
      var selected=-1;
      var i;
      var list=[{"id":"newToOld","text":strings.newToOld},{"id":"oldToNew","text":strings.oldToNew}]
      for(i=0;i<list.length;i++){
          if(this.state.newParameters.order==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.order, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.order=list[id].id; this.setState({newParameters:np}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }

  viewByRaceStatut= () => {
      var selected=-1;
      var i;
      var list=[{"id":"racesBilled","text":strings.racesBilled},{"id":"racesValidate","text":strings.racesValidate},{"id":"racesValBill","text":strings.racesValBill}]
      for(i=0;i<list.length;i++){
          if(this.state.newParameters.raceStatut==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.races, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.raceStatut=list[id].id; this.setState({newParameters:np}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }


  viewByPaymentMethod= () => {
      var selected=-1;
      var i;
      
      var list=[{id:"all",text:strings.all},{id:"onBoard",text:(info.paiementOnBoardCard==true)?strings.onBoardCash:strings.paiementOnBoard},]
      if(info.paiementOnBoardCard==true) list.push({id:"onBoardCard",text:strings.onBoardCard})


      list.push({id:"deferred",text:strings.deferredPaymentRace})
      if(info.paymentCardApp==true) list.push({id:"card",text:strings.paymentCard})
      


      for(i=0;i<list.length;i++){
          if(this.state.newParameters.paymentMethod==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.payment, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.paymentMethod=list[id]; this.setState({newParameters:np}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }


  


  viewByPartner= () => {
      var selected=-1;
      var i;
      var list=this.state.partnerList;
      for(i=0;i<list.length;i++){
          if(this.state.newParameters.partner.id==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.driver, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.partner=list[id]; this.setState({newParameters:np, viewRaceMode:"date"}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }
  viewBySourceBis= () => {
      if(this.state.withKarhoo==undefined){
        get(child(ref(getDatabase(firebase)), '/settings/withKarhoo')).then(wk => {
            var valwk=wk.val()
            this.setState({withKarhoo:(valwk==true)?true:false},() =>{this.viewBySource()})
        })
      }
      else this.viewBySource();

  }
  viewBySource= () => {
      var selected=-1;
      var i;

      var list=[{id:"all",text:strings.allSources},{id:"customerInApp",text:strings.customerInApp},{id:"provider",text:strings.providerAffair},{id:"api",text:"API"}];
      if(this.state.withKarhoo==true)list.push({id:"karhoo",text:"Karhoo"})

      for(i=0;i<list.length;i++){
          if(this.state.newParameters.partner.id==list[i].id) selected=i;
      }
      this.alert.onAlert({title:strings.source, items:list,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {var np=this.state.newParameters; np.source=list[id]; this.setState({newParameters:np, viewRaceMode:"date"}) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }







  searchBillWithNumber= () => {
    var valueSearch=parseInt(this.state.searchBill.text)
    var searchBill=this.state.searchBill;
    var i; 
    var obj;
    searchBill.loading=false; 
    if(isNaN(valueSearch)==false) get(query(ref(getDatabase(firebase), '/race'), orderByChild('billNumberDriver'), startAt(valueSearch), endAt(valueSearch))).then(billNumberDriver => {

        var valDriver=billNumberDriver.val(); 
        var valDFinal=[]
        if(valDriver!=null){
          obj=Object.keys(valDriver)
          for(i=0; i<obj.length;i++){
            valDriver[obj[i]].raceID=obj[i]
            valDriver[obj[i]].valDriver=true
            var date=new Date(valDriver[obj[i]].raceDate)
            var date2=new Date(valDriver[obj[i]].raceDate+1000*valDriver[obj[i]].estimateTimeValue)
            valDriver[obj[i]].hour=((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
            valDriver[obj[i]].hourDestination=((date2.getHours()<10)?"0":"")+date2.getHours()+":"+((date2.getMinutes()<10)?"0":"")+date2.getMinutes()
            
            if(valDriver[obj[i]].finalPriceDriverTTC!=undefined){
                valDriver[obj[i]].forceFinalPrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+valDriver[obj[i]].finalPriceDriverTTC+((this.state.money.position=="right")?(this.state.money.symbole):"")
                valDriver[obj[i]].downloadLink="https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+obj[i]+"%2F"+valDriver[obj[i]].attributedPartner.id+".pdf?alt=media";
            }
            else {
                valDriver[obj[i]].forceFinalPrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+valDriver[obj[i]].finalPrice+((this.state.money.position=="right")?(this.state.money.symbole):"")
                valDriver[obj[i]].downloadLink="https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+obj[i]+"%2Fbill.pdf?alt=media";
            
            }
            valDriver[obj[i]].date=strings.dayListComplete[ ((date.getDay()==0)?6:(date.getDay()-1))]+" "+date.getDate()+" "+strings.monthList[date.getMonth()]

            valDFinal.push(valDriver[obj[i]])
          }
        }
        
        

        if(this.state.driver==true) get(query(ref(getDatabase(firebase), "/race"), orderByChild('billNumber'), startAt(valueSearch), endAt(valueSearch))).then(billNumber => {
            var val=billNumber.val(); 
            var valFinal=[]
            if(val!=null){
              obj=Object.keys(val)
              for(i=0; i<obj.length;i++){
                val[obj[i]].raceID=obj[i]
                var date=new Date(val[obj[i]].raceDate)
                var date2=new Date(val[obj[i]].raceDate+1000*val[obj[i]].estimateTimeValue)
                val[obj[i]].hour=((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
                val[obj[i]].hourDestination=((date2.getHours()<10)?"0":"")+date2.getHours()+":"+((date2.getMinutes()<10)?"0":"")+date2.getMinutes()
                val[obj[i]].date=strings.dayListComplete[ ((date.getDay()==0)?6:(date.getDay()-1))]+" "+date.getDate()+" "+strings.monthList[date.getMonth()]
                val[obj[i]].forceFinalPrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+val[obj[i]].finalPrice+((this.state.money.position=="right")?(this.state.money.symbole):"")
                val[obj[i]].downloadLink="https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+((val[obj[i]].deferredPaymentID!=undefined)?val[obj[i]].deferredPaymentID:obj[i])+"%2Fbill.pdf?alt=media";
                valFinal.push(val[obj[i]])
              }
            }
            valFinal=valFinal.concat(valDFinal);
            searchBill.result=valFinal
            this.setState({searchBill:searchBill})
        })
        else {
            searchBill.result=valDFinal
            this.setState({searchBill:searchBill})
        }
    })

    else this.setState({searchBill:searchBill})
    


  }

exportCSV(){
  console.log("export csv")
     var list=JSON.parse(JSON.stringify(this.state.listSimplified));
     var i;
     var date, hour,name, raceI, driverName, start, end;
     var elem=""; 
     var dataExportedArray=[]; 
     dataExportedArray.push("Date, Heure, Nom client, Nom chauffeur, Mode de paiement,Montant client, Départ, Destination");
     var text="Date, Heure, Nom client,Nom chauffeur, Mode de paiement,Montant client, Départ, Destination\r"
     for(i=0;i<list.length;i++){
       raceI=list[i];
       date=((new Date(raceI.raceDate).getDate()<10)?"0":"")+new Date(raceI.raceDate).getDate()+"/"+((new Date(raceI.raceDate).getMonth()<9)?"0":"")+(new Date(raceI.raceDate).getMonth()+1); 
       hour=(((new Date(raceI.raceDate).getHours()<10)?"0":"")+new Date(raceI.raceDate).getHours()+":"+((new Date(raceI.raceDate).getMinutes()<10)?"0":"")+new Date(raceI.raceDate).getMinutes())+((raceI.estimateTimeValue!=undefined)?" - ":"")+ ((raceI.estimateTimeValue!=undefined)?(((new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getHours()<10)?"0":"")+new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getHours()+":"+((new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getMinutes()<10)?"0":"")+new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getMinutes()):"");
       name=((raceI.clientName!=undefined)?raceI.clientName:"")+" "+((raceI.clientLastName!=undefined)?raceI.clientLastName:"");
       driverName=(raceI.attributedPartner!=undefined)?raceI.attributedPartner.text:"--",
       start=raceI.racePlaceStartName.replace(/,/g, " -")
       end=(raceI.racePlaceEndName!=undefined)?raceI.racePlaceEndName.replace(/,/g, " -"):"--";
       elem=date+","+hour+","+name+","+driverName+","+raceI.priceRaceExplication+","+raceI.priceRace+","+start+","+end;
       dataExportedArray.push(elem)
       text+=elem+"\r";      
     }    
    Clipboard.setString(text);this.alert.onAlert({title:strings.copiedClipboard})
 }




  
  componentDidMount(){
    
    if(Platform.OS!="web") this.props.navigation.setOptions({ headerRight: props => <HeaderRight  info={ {filterMoney:this._filterMoney, moneySymbole:(this.state.extraEUMode==true)?this.state.money.symbole:undefined, stripeManualOnRevenus:this.state.stripeManualOnRevenus, transfertRevenu:this._viewTransfert, disableSearch:(this.state.viewSelect=="waitBill")?true:false, viewSearch:this.state.viewSearch, changeViewSearch:this._viewSearch } }   {...props} /> })

    /*this.findRemoveDeferred("9ad3f20a-09d6-457e-cfe5-5c61dc2f038f"); */

    if(getAuth(firebase).currentUser.uid!=null){
    this.changeInterval();
    this.getPartnersList();

    


  }
  }

    checkItemDeferred(action, deferredPaymentID){
      this.alert.onAlert({title:strings.isDeferred,subTitle:strings.isDeferredOkOther, buttons:[ {text: strings.yes,onPress: () => { 

        /* je recherche les courses avec cet identifiant */
        get(query(ref(getDatabase(firebase), "/race"), orderByChild('deferredPaymentID'), startAt(deferredPaymentID), endAt(deferredPaymentID))).then(value => {
            var val=value.val();
            if(val!=null){
              var list=Object.keys(val)
              var i; 
              var listSimplified=JSON.parse(JSON.stringify(this.state.listSimplified))
              for(i=0; i<list.length;i++){
                
                const fireInfo={} 
                fireInfo['race/' +list[i]+"/checkedItem"]=(action=="remove")?null:true;
                update(ref(getDatabase(firebase)), fireInfo)

                var j; 

                for(j=0; j<this.state.listSimplified.length;j++){
                  if(listSimplified[j].raceID==list[i]) listSimplified[j].checkedItem=(action=="remove")?false:true; 
                }
              }
              this.setState({listSimplified:listSimplified})
            }
        })
    

      }},{text: strings.no,onPress: () => { }}] });  
    }


  checkItem(keyRace,raceI){
      var listSimplified=JSON.parse(JSON.stringify(this.state.listSimplified))
      const fireInfo={} 
      if(listSimplified[keyRace].checkedItem==true){
          listSimplified[keyRace].checkedItem=false;
          /*je copie l'info sur le serveur */
          
          fireInfo['race/' +raceI.raceID+"/checkedItem"]=null

          /*si c'est une course avec un id de paiement différé, je propose de faire la meme chose pour les autres*/
          if(listSimplified[keyRace].deferredPaymentID!=undefined) this.checkItemDeferred("remove",listSimplified[keyRace].deferredPaymentID)

      }
      else {
          listSimplified[keyRace].checkedItem=true;
          /*je copie l'info sur le serveur */
          fireInfo['race/' +raceI.raceID+"/checkedItem"]=true
          /*si c'est une course avec un id de paiement différé, je propose de faire la meme chose pour les autres*/
          if(listSimplified[keyRace].deferredPaymentID!=undefined) this.checkItemDeferred("check",listSimplified[keyRace].deferredPaymentID)
      }
      update(ref(getDatabase(firebase)), fireInfo)
      this.setState({listSimplified:listSimplified})
      
      

  }


  getPartnersList(){

    var params={uuid:getAuth(firebase).currentUser.uid, viewAllPartners:true}

    
    fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getPartner", {
        body: JSON.stringify(params),
        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json()).then((responseJson) => {
          var res=responseJson
          var res2=[{id:"all",text:strings.all}]
          var i;
          for(i=0;i<res.length;i++) res2.push(res[i])
          this.setState({partnerList:res2})
          
        }).catch((err) => { console.log("error getPartnersList"); console.log(err); timer.setTimeout("getPartnersList", () => { this.getPartnersList();  }, 2000);   })
    }

  
    





  render() {
    let moneyListTotal=moneyList

    return (
      <StyleContext.Consumer>{style => 

      <View>

      <ScrollView style={{backgroundColor:style.backgroundColor, height:"100%",}}>

      {(Platform.OS=="web") && <View style={{height:65,backgroundColor:style.backgroundColorContrast, justifyContent: 'space-between',width:Dimensions.get('window').width, flexDirection: 'row', alignItems:"center"}}>
                 <View style={{flexDirection: 'row', alignItems:"center"}}>
                    {this.state.viewerPartner==false && <MavMiniButton style={{marginLeft:15}} icon={(style.mode=="dark")?require('../assets/waiting_black.png'):require('../assets/waiting_white.png')} text={(this.state.viewSelect=="revenue")?strings.billWaiting:strings.seeBill} onlyButton={true}  onPress={()=>{ this.setState(() => ({viewSelect:(this.state.viewSelect=="revenue")?"waitBill":"revenue" }),function(){ this.changeInterval(); })  }} />}
                              {this.state.viewerPartner==true && <MavMiniButton style={{marginLeft:15}} icon={(style.mode=="dark")?require('../assets/partner_dark.png'):require('../assets/partner_light.png')} text={strings.seeAll} onlyButton={true}  onPress={()=>{ this.setState(() => ({viewerPartner:false}),function(){ this.updateData(); })  }} />} 
                                <MavMiniButton style={{marginLeft:15, marginRight:15}} icon={(style.mode=="dark")?require('../assets/settings_black.png'):require('../assets/settings_white.png')} text={(this.state.viewParamsWindow==true)?strings.hideParams:strings.seeParams} onlyButton={true}  onPress={()=>{ this.setState({viewParamsWindow:!this.state.viewParamsWindow}) }} />
        

            </View>
          <View style={{flexDirection: 'row', alignItems:"center"}}>
           
           <TouchableHighlight underlayColor={"#00000000"} onPress={() => { this.changeInterval("before") }} style={{marginLeft:10,alignItems:'center',justifyContent:'center'}} >                    

            <View style={{flex:1,alignItems:'center',justifyContent:'center'}}>

            <Image source={(style.mode=="dark")?require('../assets/calendar_before_dark.png'):require('../assets/calendar_before_light.png')} style={{ width: 15, height: 30 }} />                
             </View>              
           </TouchableHighlight>                

           <Text style={{fontSize: 25,fontWeight: 'bold',color:style.textInputColor, marginLeft:15, marginRight:15}}>{(this.state.mode=="threeMonth")?( strings.monthList[new Date(this.state.dateStart).getMonth()]+" "+strings.at.toLowerCase()+" "+strings.monthList[(  (new Date(this.state.dateStart).getMonth()+2==12)?0: (     ((new Date(this.state.dateStart).getMonth()+2)<13)?(new Date(this.state.dateStart).getMonth()+2):(12-new Date(this.state.dateStart).getMonth())))].toLowerCase() )  :(  (this.state.mode=="day")?( (new Date(this.state.dateStart).getDate() < 10 ? '0' : '') +new Date(this.state.dateStart).getDate()+" "+strings.monthList[new Date(this.state.dateStart).getMonth()].toLowerCase()+new Date(this.state.dateStart).getFullYear()   ): (this.state.mode=="week"?((new Date(this.state.dateStart).getDate() < 10 ? '0' : '') +new Date(this.state.dateStart).getDate() +'/' +(new Date(this.state.dateStart).getMonth() + 1 < 10? '0': '') +(new Date(this.state.dateStart).getMonth() + 1) +' '+strings.toDate+' ' +(new Date(this.state.dateEnd).getDate() < 10 ? '0' : '') +new Date(this.state.dateEnd).getDate() +'/' +(new Date(this.state.dateEnd).getMonth() + 1 < 10 ? '0' : '') +(new Date(this.state.dateEnd).getMonth() + 1)):( (strings.monthList[new Date(this.state.dateStart).getMonth()]+" "+(new Date(this.state.dateStart).getFullYear()))) ))}</Text>

    <TouchableHighlight underlayColor={"#00000000"} onPress={() => {this.changeInterval("after") }} style={{marginRight:10,alignItems:'center',justifyContent:'center'}} >                    
    <View style={{flex:1,alignItems:'center',justifyContent:'center'}}>
                            <Image source={(style.mode=="dark")?require('../assets/calendar_after_dark.png'):require('../assets/calendar_after_light.png')} style={{ width: 15, height: 30 }} />                 
   </View>              
   </TouchableHighlight>
</View>           

    {this.state.viewSelect!="waitBill" && <MavSelector style={{width:350, marginTop:-10}} selected={(this.state.simplified==true)?1:0} textLeft={strings.viewComplete} textRight={strings.viewSimplified} onChange={(value)=>{ this.setState({simplified:(value==0)?false:true}) }}/>}
         <View style={{flexDirection: 'row', alignItems:"center"}}>
                  {(this.state.viewSelect!="waitBill") && <TouchableHighlight style={{ marginRight:10, alignItems:"center", justifyContent:"center"}} underlayColor={"#FFFFFF00"} onPress={() => { this._viewSearch(); }}>
                   <Image source={(style.mode=="dark")?require('../assets/search_white.png'):require('../assets/search_black.png')} style={{ width: 25, height: 25 }}/>
              </TouchableHighlight>}

    {(this.state.extraEUMode==true) && <View style={{height: 60,alignItems: 'center',justifyContent:"center"}}>                

      <TouchableHighlight underlayColor={'#FFFFFF00'}  onPress={() => { this._filterMoney() }}>                      
        <Text style={{textAlign: 'center',fontSize: style.textInputFontSize,color: style.textInputColor,marginRight:10}}>{strings.in+" "+this.state.money.symbole}</Text>
      </TouchableHighlight>

   </View>}

   </View>
    </View>}


    {(this.state.viewSelect=="waitBill" && info.debugMAV==true) &&
      <TouchableHighlight style={{marginTop:10, height:20, backgroundColor:"#FF0000", alignItems:"center"}} underlayColor={'#FFFFFF00'} onPress={() => { this.removeDeferred() }}>
                <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>Supprimer une facture différé</Text>
          </TouchableHighlight>}













        
        {(Platform.OS!="web") && <View style={{ height: 60, backgroundColor: style.colorDark,flexDirection: 'row',width:Dimensions.get('window').width }}>
         

        


          <View style={{flex: 1,flexDirection: 'row',justifyContent: 'space-between',alignItems: 'center',marginLeft: "10%",marginRight: "10%"}}>
            <TouchableHighlight
              underlayColor="rgba(0,0,0,0)"
              onPress={() => {
                this.changeInterval("before");
              }}>
              <Image
                source={require('../assets/revenue_before.png')}
                style={{ width: 30, height: 30 }}
              />
            </TouchableHighlight>

            <TouchableHighlight style={{flex: 1,width: Dimensions.get('window').width * 0.6,}} underlayColor="rgba(0,0,0,0)" onPress={() => {this.setState({viewParamsWindow:!this.state.viewParamsWindow}) }}>
              <View>
              {(this.state.viewerPartner==true && Platform.OS=="web" && this.state.partnerText!=null) && <Text allowFontScaling={false} style={{textAlign: 'center',fontSize: style.textInputFontSize*0.8,color: '#ffffff',}}>{this.state.partnerText}</Text>}

            <Text allowFontScaling={false} style={{textAlign: 'center',fontSize: style.textInputFontSize*1.2,color: '#ffffff', }}>
              
              
              { (this.state.mode=="threeMonth")?( strings.monthList[new Date(this.state.dateStart).getMonth()]+" "+strings.at.toLowerCase()+" "+strings.monthList[(  (new Date(this.state.dateStart).getMonth()+2==12)?0: (     ((new Date(this.state.dateStart).getMonth()+2)<13)?(new Date(this.state.dateStart).getMonth()+2):(12-new Date(this.state.dateStart).getMonth())))].toLowerCase() ) :( (this.state.mode=="day")?( (new Date(this.state.dateStart).getDate() < 10 ? '0' : '') +new Date(this.state.dateStart).getDate()+" "+strings.monthList[new Date(this.state.dateStart).getMonth()].toLowerCase()   ): (this.state.mode=="week"?((new Date(this.state.dateStart).getDate() < 10 ? '0' : '') +new Date(this.state.dateStart).getDate() +'/' +(new Date(this.state.dateStart).getMonth() + 1 < 10? '0': '') +(new Date(this.state.dateStart).getMonth() + 1) +' '+strings.toDate+' ' +(new Date(this.state.dateEnd).getDate() < 10 ? '0' : '') +new Date(this.state.dateEnd).getDate() +'/' +(new Date(this.state.dateEnd).getMonth() + 1 < 10 ? '0' : '') +(new Date(this.state.dateEnd).getMonth() + 1)):( (strings.monthList[new Date(this.state.dateStart).getMonth()]+" "+(new Date(this.state.dateStart).getFullYear()))) ) )}
            </Text>



             <Text allowFontScaling={false} style={{textAlign: 'center',fontSize: style.textInputFontSize*0.8,color: '#ffffff',}}>{(this.state.viewParamsWindow==true)?strings.clickToHideParameter:strings.clickToViewParameter}</Text>
            </View>
            </TouchableHighlight>
            <TouchableHighlight
              underlayColor="rgba(0,0,0,0)"
              onPress={() => {
                this.changeInterval("after")
              }}>
              <Image
                source={require('../assets/revenue_next.png')}
                style={{ width: 30, height: 30 }}
              />
            </TouchableHighlight>
          </View>


          {(this.state.extraEUMode==true && Platform.OS=="web") && <View style={{height: 60,alignItems: 'center',justifyContent:"center"}}>
             <TouchableHighlight underlayColor={'#FFFFFF00'}  onPress={() => { this._filterMoney() }}>
                  <Text style={{textAlign: 'center',fontSize: style.textInputFontSize,color: '#ffffff',marginRight:10}}>{strings.in+" "+this.state.money.symbole}</Text>
              </TouchableHighlight>
          </View>}

        </View>}

        {this.state.viewParamsWindow==true && <View style={{width:Dimensions.get('window').width,backgroundColor:style.backgroundColorContrast, shadowOpacity:0.3,shadowRadius:2,shadowOffset: {height: 2,width: 0},elevation:1,}}> 
              
              <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.viewByMode()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.viewBy+" : "} text={(this.state.newParameters.mode=="day")?strings.day:((this.state.newParameters.mode=="week")?strings.week:((this.state.newParameters.mode=="month")?strings.month:("3 "+strings.month) ) )} editable={false}/>
              </TouchableHighlight>

              <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.viewByOrder()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.order+" : "} text={(this.state.newParameters.order=="newToOld")?strings.newToOld:strings.oldToNew} editable={false}/>
              </TouchableHighlight>

              {((this.state.hidePriceRaceForDriver==false || this.state.driver==true) && this.state.viewSelect=="revenue") && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.viewByRaceStatut()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.races+" : "} text={strings[this.state.newParameters.raceStatut]} editable={false}/>
              </TouchableHighlight>}

              {(this.state.driver==true && this.state.viewSelect=="revenue") && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.viewBySourceBis()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.source+" : "} text={this.state.newParameters.source.text} editable={false}/>
              </TouchableHighlight>}

              {(this.state.viewerPartner==false && this.state.driver==true && this.state.viewSelect=="revenue") && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.viewByPartner()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.driver+" : "} text={this.state.newParameters.partner.text} editable={false}/>
              </TouchableHighlight>}

              {(this.state.driver==true && this.state.viewSelect=="revenue") && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.viewByPaymentMethod()  }}>
                  <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.payment+" : "} text={this.state.newParameters.paymentMethod.text} editable={false}/>
              </TouchableHighlight>}

              

              <MavButton text={strings.validate} style={{marginTop:15,marginBottom:15}} onPress={()=>{ 
                  this.setState({viewParamsWindow:false,mode:this.state.newParameters.mode,paymentMethod:this.state.newParameters.paymentMethod, source:this.state.newParameters.source.id, order:this.state.newParameters.order,partner:this.state.newParameters.partner,raceStatut:this.state.newParameters.raceStatut},() =>{this.changeInterval()})
              }}/>
              
              

        </View>}



        {this.state.waiting==true && <ActivityIndicator style={{marginTop:30}} size="large" color={style.color1} />}
        
        {this.state.waiting!=true && <View style={{flexDirection:(Dimensions.get('window').width>Dimensions.get('window').height)?"row":"column"}}>

        {(this.state.viewSelect=="revenue" && this.state.simplified!=true) && <View>
            {(this.state.mode!="day") && <View style={{marginLeft: Dimensions.get('window').width*style.textInputMarginLeft*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),marginRight: Dimensions.get('window').width *style.textInputMarginLeft*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1)}}>

            
              {this.state.dataPerDay.map((rowData,i)=>(
              <View
                style={{
                  position: 'absolute',
                  width: ((this.state.dataPerDay.length==7)?Dimensions.get('window').width * 0.05:((Dimensions.get('window').width *(1- 2*style.textInputMarginLeft))-(0.145*Dimensions.get('window').width))/this.state.dataPerDay.length)*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),
                  height: 120 *(((rowData>0)?rowData:0) / this.state.dataPerDayMax),
                  backgroundColor: style.color1,
                  marginLeft: ((this.state.dataPerDay.length==7)?Dimensions.get('window').width * (0.125+0.1*i):(0.125*Dimensions.get('window').width)+(i)*((Dimensions.get('window').width *(1- 2*style.textInputMarginLeft))-(0.145*Dimensions.get('window').width))/this.state.dataPerDay.length)*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),
                  marginTop: 142 - 120 * (((rowData>0)?rowData:0) / this.state.dataPerDayMax),
                }}
              />
              ))}
             

              <View
                style={{marginTop: 10,flexDirection: 'row',justifyContent: 'space-between',alignItems: 'center',height: 25,}}>
                <Text allowFontScaling={false} style={{width: Dimensions.get('window').width * 0.19*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),marginLeft:-Dimensions.get('window').width *style.textInputMarginLeft*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1), textAlign: 'right', marginRight:5,fontSize: style.textInputFontSize*0.9,color:style.textInputColor}}>{((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.dataPerDayMax.toFixed(0)+((this.state.money.position=="right")?(this.state.money.symbole):"") }</Text>
                <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,width: Dimensions.get('window').width * 0.7*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),}}/>
              </View>

              <View style={{marginTop: 35,height: 25,flexDirection: 'row',justifyContent: 'space-between',alignItems: 'center',}}>
                <Text allowFontScaling={false} style={{color:style.textInputColor,width: Dimensions.get('window').width * 0.19*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),marginLeft:-Dimensions.get('window').width *style.textInputMarginLeft*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),textAlign: 'right',marginRight:5,fontSize: style.textInputFontSize*0.9}}>{((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(this.state.dataPerDayMax / 2).toFixed(0)+((this.state.money.position=="right")?(this.state.money.symbole):"") }</Text>
                <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,width: Dimensions.get('window').width * 0.7*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),}}/>
              </View>

              <View style={{marginTop: 35,height: 25,flexDirection: 'row',justifyContent: 'space-between',alignItems: 'center',}}>
                <Text allowFontScaling={false} style={{color:style.textInputColor,width: Dimensions.get('window').width * 0.1*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),textAlign: 'center',}}/>
                <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,width: Dimensions.get('window').width * 0.7*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1),}}/>
              </View>

            </View>}

            <View style={{flexDirection: 'row',justifyContent: 'center',alignItems: 'center',marginTop: 10,marginLeft:10, marginRight:10}}>
              <View>
                <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontWeight: 'bold',fontSize: style.textInputFontSize*1.2,}}> {((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZone+((this.state.money.position=="right")?(this.state.money.symbole):"")  } </Text>
                <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontSize: style.textInputFontSize*0.8}}>{strings.billedToClient}</Text>
                {this.state.raceStatut=="racesValBill" && <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontSize: style.textInputFontSize*0.8,}}> {strings.includeNotBilled+ " : "+ (((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.totalZoneOnlyValidate+((this.state.money.position=="right")?(this.state.money.symbole):"") ) } </Text>}
              </View>
              
              {this.state.totalZoneByType!=false && <TouchableHighlight underlayColor={'#FFFFFF00'} style={{marginLeft:5}}  onPress={() => { this.viewTotalZoneByType() }}>
                  <Image source={(style.mode=="dark")?require('../assets/iconi.png'):require('../assets/iconi.png')} style={{ width: 18, height: 18, }}/>
              </TouchableHighlight>}

              <View style={{marginLeft:25,marginRight:25,width: 1,height: 50,backgroundColor: style.textInputLineColor,}} />


               {(this.state.priceDriverTotal!=0) && <View>
                  <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontWeight: 'bold',fontSize: style.textInputFontSize*1.2,}}> {((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.priceDriverTotal+((this.state.money.position=="right")?(this.state.money.symbole):"")} </Text>
                  <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontSize: style.textInputFontSize*0.8,}}>{strings.billedToDriver}</Text>
                </View>}
                {(this.state.priceDriverTotal!=0) && <View style={{marginLeft:25,marginRight:25,width: 1,height: 50,backgroundColor: style.textInputLineColor,}} />}

                <View>
                  <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontWeight: 'bold',fontSize: style.textInputFontSize*1.2,}}> {this.state.totalRace} </Text>
                  <Text allowFontScaling={false} style={{color:style.textInputColor,textAlign: 'center',fontSize: style.textInputFontSize*0.8,}}>{strings.races}</Text>
                </View>

              
              </View>

            {(this.state.viewSelect=="revenue" && this.state.waiting==false && !(Dimensions.get('window').width>Dimensions.get('window').height)) && <View style={{marginTop:20,marginBottom:5,height: style.textLineHeight,backgroundColor: style.textInputLineColor,width: Dimensions.get('window').width}}/>}
            
            {(this.state.viewSelect=="revenue" && this.state.waiting==false && this.state.debugRevenue!=true && this.state.driver==true) && <MavSelector style={{marginBottom:0,marginTop:(Dimensions.get('window').width>Dimensions.get('window').height)?10:undefined, width:(Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').width*0.5:undefined }} selected={(this.state.viewRaceMode=="date")?0:( (this.state.viewRaceMode=="client")?1:0.5 )} textLeft={strings.byDate} textCenter={(this.state.newParameters.partner.id=="all")?strings.byDriver:undefined} textRight={strings.byCustomer} onChange={(value)=>{ 
                var viewRaceMode=(value!=0)?( (value==0.5)?"driver":"client"):"date"
                this.setState({viewRaceMode:viewRaceMode})
            }}/>}

        </View>}

        
        {(this.state.viewSelect=="revenue" && this.state.simplified!=true) && <View style={{width:Dimensions.get('window').width*((Dimensions.get('window').width>Dimensions.get('window').height)?0.5:1)}}>


            {this.state.viewRaceMode=="date" && ( (this.state.order=="newToOld")?  Object.keys(this.state.listDate).sort(function(a, b) {return b - a}) : Object.keys(this.state.listDate) )   .map((rowData,i)=>(
                <View>
                    <Text style={{marginLeft:"10%",marginTop:15, fontSize:style.textInputFontSize*1.2,color:style.textInputColor, fontWeight: 'bold',}}>{this.state.listDate[rowData].name}</Text>
                    {this.state.listDate[rowData].list.map((raceI,i)=>(
                        <View>
                            <BookingView viewDebug={() => { this.setState({debugInfo:raceI,debugInfoID:raceI.id, viewDebugInfo:true}) }} viewPDFFile={(data) => { this.viewPDFFile(data) }} mode={"revenue"} enableDriverNameInRace={(this.state.driver || raceI.priceRaceDriver!=undefined)} data={raceI} style={{width:"80%", marginLeft:"10%"}}/>
                            {(i<this.state.listDate[rowData].list.length-1) && <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: 10,marginBottom:10, width:"80%", marginLeft:"10%"}}/>}
                        </View>
                    ))}
                </View>

            ))}

            {this.state.viewRaceMode=="driver" && Object.keys(this.state.listDriver).map((rowData,i)=>(
                <View>
                    <Text style={{marginLeft:"10%",marginTop:15, fontSize:style.textInputFontSize*1.2,color:style.textInputColor, fontWeight: 'bold',}}>{this.state.listDriver[rowData].name}</Text>
                    {this.state.listDriver[rowData].list.map((raceI,i)=>(
                        <View>
                            <BookingView viewDebug={() => { this.setState({debugInfo:raceI,debugInfoID:raceI.id, viewDebugInfo:true}) }} viewPDFFile={(data) => { this.viewPDFFile(data) }} mode={"revenue"} enableDriverNameInRace={raceI.priceRaceDriver!=undefined} data={raceI} style={{width:"80%", marginLeft:"10%"}}/>
                            {(i<this.state.listDriver[rowData].list.length-1) && <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: 10,marginBottom:10, width:"80%", marginLeft:"10%"}}/>}
                        </View>
                    ))}
                </View>

            ))}

            {this.state.viewRaceMode=="client" && Object.keys(this.state.listClient).map((rowData,i)=>(
                <View>
                    <Text style={{marginLeft:"10%",marginTop:15, fontSize:style.textInputFontSize*1.2,color:style.textInputColor, fontWeight: 'bold',}}>{this.state.listClient[rowData].name}</Text>
                    {this.state.listClient[rowData].provider==true && <Text style={{marginLeft:"10%",marginTop:-5, fontSize:style.textInputFontSize,color:style.textInputColor, fontStyle: 'italic'}}>{strings.providerAffair}</Text>}
                    
                    {this.state.listClient[rowData].list.map((raceI,i)=>(
                        <View>
                            <BookingView viewDebug={() => { this.setState({debugInfo:raceI,debugInfoID:raceI.id, viewDebugInfo:true}) }} viewPDFFile={(data) => { this.viewPDFFile(data) }} mode={"revenue"} enableDriverNameInRace={(this.state.driver || raceI.priceRaceProvider!=undefined)} data={raceI} style={{width:"80%", marginLeft:"10%"}}/>
                            {(i<this.state.listClient[rowData].list.length-1) && <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: 10,marginBottom:10, width:"80%", marginLeft:"10%"}}/>}
                        </View>
                    ))}
                </View>

            ))}

            {(this.state.waiting==false && this.state.viewSelect=="revenue" && Object.keys(this.state.listBill).length==0) && <Text style={{width:"100%",marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.nothingToView}</Text>}
          

            {(this.state.waiting==false && this.state.viewSelect=="revenue" && Object.keys(this.state.listBill).length>0) && <View style={{alignItems:"center",justifyContent:"center", marginTop:50,marginBottom:50}}>
                  <MavButton text={strings.sendByMail} onlyButton={true} onPress={()=>{  this.sendByMail();  }}/>
                  <MavButton style={{marginTop:10}} text={strings.exportCSV} onlyButton={true} onPress={()=>{  this.exportCSV()  }}/>
              </View>}

            


            

        </View>}


        {(this.state.viewSelect=="revenue" && this.state.simplified==true) && <View style={{flexDirection: 'row',height:45, position:"absolute",backgroundColor:style.backgroundColor, }}>
            <View style={{width:Dimensions.get('window').width*0.08,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.date}</Text>
            </View>  

            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
            <View style={{width:Dimensions.get('window').width*0.08,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.hour}</Text>
            </View> 

            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
            <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.clientInfo}</Text>
            </View> 
                
            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/> 
            <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.driverInfo}</Text>
            </View> 
            
            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
            <View style={{width:Dimensions.get('window').width*0.30,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.trip}</Text>
            </View>

            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
            <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.paymentMode}</Text>
            </View> 
                    
            <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
            <View style={{width:Dimensions.get('window').width*0.122,alignItems:"center", justifyContent:"center",}}>
              <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{strings.amount}</Text>
            </View>
        </View>}



















        </View>}
            

           
        

        {(this.state.viewSelect=="revenue" && this.state.simplified==true) && <ScrollView style={{height:Dimensions.get('window').height-160,zIndex:10}} >
            {this.state.listSimplified.map((raceI,keyRace)=>(
                <View style={{flexDirection: 'row',height:45, backgroundColore:style.backgroundColor, backgroundColor:style.color1, marginTop:(keyRace==0)?45:undefined  }}>
                    <View style={{width:Dimensions.get('window').width*0.08,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0 )?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                        <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize*1.2, fontWeight: 'bold'}}>{((new Date(raceI.raceDate).getDate()<10)?"0":"")+new Date(raceI.raceDate).getDate()+"/"+((new Date(raceI.raceDate).getMonth()<9)?"0":"")+(new Date(raceI.raceDate).getMonth()+1)  }</Text>
                    </View> 
                    <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
                    <View style={{width:Dimensions.get('window').width*0.08,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0 )?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                        <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize*1,}}>{(((new Date(raceI.raceDate).getHours()<10)?"0":"")+new Date(raceI.raceDate).getHours()+":"+((new Date(raceI.raceDate).getMinutes()<10)?"0":"")+new Date(raceI.raceDate).getMinutes())+((raceI.estimateTimeValue!=undefined)?" - ":"")+ ((raceI.estimateTimeValue!=undefined)?(((new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getHours()<10)?"0":"")+new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getHours()+":"+((new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getMinutes()<10)?"0":"")+new Date(raceI.raceDate+raceI.estimateTimeValue*1000).getMinutes()):"")}</Text>
                    </View> 
                    <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
                    <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0 )?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                        
                        {raceI.clientEnterprise!=undefined && <Text numberOfLines={1} ellipsizeMode={"tail"} style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{raceI.clientEnterprise}</Text>}
                        <Text numberOfLines={1} ellipsizeMode={"tail"} style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize*( (raceI.clientEnterprise!=undefined)?0.8:1 )}}>{((raceI.clientName!=undefined)?raceI.clientName:"")+" "+((raceI.clientLastName!=undefined)?raceI.clientLastName:"")}</Text>
                        {(raceI.clientPhone!=undefined && raceI.clientPhone!="" && raceI.clientPhone!="+33" && raceI.clientEnterprise==undefined) && <Text style={{marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.8}}>{raceI.clientPhone}</Text>}
                        {(raceI.viaAPI!=undefined || raceI.providerName!=undefined || raceI.karhooProvider!=undefined   ) && <Text style={{marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.7}}>{strings.provider+" "+((raceI.viaAPI!=undefined)?"API":( (raceI.karhooProvider!=undefined)?"Karhoo":( (raceI.providerEnterprise!=undefined)?raceI.providerEnterprise:(raceI.providerName+" "+raceI.providerLastName) ) ) ) }</Text>}                           
                    </View> 


                    <View style={{width:1, height:"100%", backgroundColor:"grey"}}/> 
                    <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0 )?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                      <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{(raceI.attributedPartner!=undefined)?raceI.attributedPartner.text:"---"}</Text>
                      {(raceI.attributedPartner!=undefined && raceI.attributedPartner.car!=undefined) && <Text style={{marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.7}}>{((raceI.attributedPartner.car.brand!=undefined)?raceI.attributedPartner.car.brand:"")+" "+((raceI.attributedPartner.car.model!=undefined)?raceI.attributedPartner.car.model:"")+" "+((raceI.attributedPartner.car.immatriculation!=undefined)?("("+raceI.attributedPartner.car.immatriculation+")"):"")}</Text>}
                    </View> 
                    <View style={{width:1, height:"100%", backgroundColor:"grey"}}/> 


                    <View style={{width:Dimensions.get('window').width*0.30,alignItems:"center", flexDirection:"row", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0 )?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                        <View style={{width:Dimensions.get('window').width*0.12,}}> 
                          {raceI.racePlaceStartList.map((value, keyRace)=>(  <Text numberOfLines={1} ellipsizeMode={"tail"}  style={{marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.8}}>{value}</Text> ))}
                        </View>
                        <View style={{width:Dimensions.get('window').width*0.03, alignItems:"center", justifyContent:"center"}}>
                            <Image source={(raceI.stopList!=undefined)?((style.mode=="dark")?require('../assets/etc_white.png'):require('../assets/etc_black.png')) :((style.mode=="dark")?require('../assets/arrowRight_white.png'):require('../assets/arrowRight_black.png'))} style={{ width: 15, height: 15, }} />
                        </View>                           
                    
                        <View style={{width:Dimensions.get('window').width*0.12, }}>
                          {(raceI.racePlaceEndName!=undefined && raceI.racePlaceEndName!="") && raceI.racePlaceEndList.map((value, keyRace)=>( 
                           <Text numberOfLines={1} ellipsizeMode={"tail"}  style={{textAlign:"right", marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.8}}>{value}</Text>
                          ))}
                          {(raceI.racePlaceEndName==undefined || raceI.racePlaceEndName=="") && <Text numberOfLines={1} ellipsizeMode={"tail"}  style={{textAlign:"right", marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.8}}>{strings.provision}</Text>}
                        </View>
                    </View>
          
                <View style={{width:1, height:"100%", backgroundColor:"grey"}}/>
                <View style={{width:Dimensions.get('window').width*0.12,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0)?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                    <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize}}>{raceI.priceRaceExplication }</Text>
                    {raceI.billNumber!=undefined && <Text style={{marginLeft:2,marginRight:2, color:style.textInputColor,fontSize: style.textInputFontSize*0.65}}>{strings.bill+" n° "+raceI.billNumber }</Text>}
                    
                </View>

                <View style={{width:1, height:"100%", backgroundColor:"grey"}}/> 
                <View style={{width:Dimensions.get('window').width*0.123,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0)?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                     <Text style={{marginLeft:2,marginRight:2, marginTop:2,  color:style.textInputColor,fontSize: style.textInputFontSize*1.2, fontWeight: 'bold'}}>{raceI.priceRace }</Text> 
                 </View> 
                
                <View style={{width:Dimensions.get('window').width*0.03,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0)?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                    {(raceI.downloadBillLink!=undefined || raceI.downloadDriverBillLink!=undefined) && <TouchableHighlight onPress={() => {if(raceI.downloadBillLink!=undefined && raceI.downloadDriverBillLink==undefined) this.viewPDFFile(raceI.downloadBillLink); else if(raceI.downloadBillLink==undefined && raceI.downloadDriverBillLink!=undefined) this.viewPDFFile(raceI.downloadDriverBillLink);else this.alert.onAlert({title:strings.whatBillyouSee,buttons:[ {text: strings.customer,onPress: () => {this.viewPDFFile(raceI.downloadBillLink)}},{text: strings.driver,onPress: () => {this.viewPDFFile(raceI.downloadDriverBillLink)}},{text: strings.cancel,style:"cancel",onPress: () => {}} ],}); }} underlayColor={"#FFFFFF00"}  style={{justifyContent: 'center',alignItems: 'center',height:22,width:22, marginRight:10}}>
                     <Image source={(style.mode=="dark")?require('../assets/download_dark.png'):require('../assets/download_light.png')} style={{ width: 22, height: 22 }}/>
                      </TouchableHighlight>}
                </View> 

                <View style={{width:Dimensions.get('window').width*0.022,alignItems:"center", justifyContent:"center",backgroundColor:(style.mode=="dark")?((keyRace%2==0)?"#1D1E20F0":"#1D1E20B0"): ((keyRace%2==0 )?"#FFFFFFF0":"#FFFFFFB0")}}>
                    {(raceI.status=="invoiced" || (raceI.status=="finish" && info.disableBillForBasic!=true)) && <TouchableHighlight accessibilityLabel={(this.props.arrowEnabled)?strings.coche:strings.notCoche} underlayColor={'rgba(255,255,255,0)'} onPress={() => { this.checkItem(keyRace,raceI) }} >
                          <View style={{justifyContent:"center",alignItems:'center',borderWidth:1,borderColor: style.textInputLineColor,height:20,width:20,marginRight:5,backgroundColor:(raceI.checkedItem==true)?style.color1:undefined }}>
                            {(raceI.checkedItem==true) && <Text allowFontScaling={false} style={{fontSize: style.textInputFontSize,color:style.backgroundColor,fontWeight: 'bold',}}>&#10003;</Text>}
                          </View>
                      </TouchableHighlight>}
                </View> 
          </View>
          ))}

</ScrollView>}



















      {(this.state.waiting==false && this.state.viewSelect=="waitBill") && Object.keys(this.state.list).map(item => (







        <MavViewMore marginSize={"5%"} icon={(this.state.list[item].clientType=="karhoo")?( (style.mode=="dark")?require('../assets/logo_karhoo_black.png'):require('../assets/logo_karhoo_white.png')): ( (this.state.list[item].clientType=="provider")?( (style.mode=="dark")?require('../assets/user_partner_black.png'):require('../assets/user_partner_white.png')):((this.state.list[item].clientType=="customerPro")?( (style.mode=="dark")?require('../assets/user_pro_black.png'):require('../assets/user_pro_white.png')):  ( (style.mode=="dark")?require('../assets/user_black.png'):require('../assets/user_white.png')))) } text={this.state.list[item].name} iconBackgroundColor={style.color1} arrowRight={true} 

         arrowEnabled={(this.state.list[item].enableCounter==0)?false:(this.state.list[item].enableCounter==Object.keys(this.state.list[item].raceList).length)?true:"partial"} onArrowChange={()=>{ 

          var list=this.state.list; 
          var listObj=Object.keys(this.state.list[item].raceList); 
          var i;
          var enableSelected=this.state.enableSelected;
          var decoche=this.state.list[item].enableCounter==listObj.length;
          for(i=0; i<listObj.length;i++){

            if(decoche==true){
              /*c'était tout coché, je décoche*/
              if(list[item].raceList[listObj[i]].enable==true){list[item].raceList[listObj[i]].enable=false; enableSelected--; }
            }
            else if(list[item].raceList[listObj[i]].enable==false){list[item].raceList[listObj[i]].enable=true; enableSelected++; }


            
          }

           
           if(decoche==true) list[item].enableCounter=0; 
           else list[item].enableCounter=listObj.length; 

            this.setState({list:list,enableSelected:enableSelected})  

            }} maxiMode={"partial"} >

          {item=="karhoo" && <Text style={{marginLeft:"10%", marginRight:"10%", marginBottom:10, color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "justify", marginTop:10}}>{strings.deferredKarhoo}</Text>}
          

            {Object.keys(this.state.list[item].raceList).map((race,raceI) => (
                  <MavTextInput style={{marginTop:5,}} arrow={true} enableInfo={(Platform.OS!="web")?true:false}  onEnableInfo={() => {var data=this.state.list[item].raceList[race]; this.props.navigation.navigate('RaceInfo',{removeOption:true, data:data, pricingView:{} }) }} arrowEnabled={ this.state.list[item].raceList[race].enable} onChange={()=>{  var list=this.state.list; list[item].raceList[race].enable=!list[item].raceList[race].enable; var enableSelected=this.state.enableSelected; if(list[item].raceList[race].enable==true) {enableSelected++; list[item].enableCounter++; } else {enableSelected--; list[item].enableCounter--}  this.setState({list:list,enableSelected:enableSelected})    }}  backgroundColor={style.backgroundColorContrast} disableLine={((Object.keys(this.state.list[item].raceList).length-1)==raceI)?true:false} textExplication={this.state.list[item].raceList[race].raceDateFixed} disabledText={true} textInputFlex={0.2} textExplicationMini={strings.driver+" : "+this.state.list[item].raceList[race].driverText} textRight={this.state.list[item].raceList[race].estimatePrice} />
              ))}


        </MavViewMore>))}








   

          {(this.state.waiting==false && this.state.viewSelect=="waitBill" && Object.keys(this.state.list).length==0) && <Text style={{width:"100%",marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.nothingToView}</Text>}
          
          <View style={{marginTop:30,flexDirection:"row", justifyContent:"center"}} >
              {(this.state.enableSelected>0 && this.state.viewSelect=="waitBill" && this.state.waiting!=true) && <MavButton onlyButton={true} text={(Object.keys(this.state.list).length==1)?strings.generateBill:strings.generateBills}  onPress={()=>{ this.generateBills()  }}/>} 
              {(this.state.enableSelected>0 && this.state.viewSelect=="waitBill" && this.state.waiting!=true && info.stripePublicKey!=undefined && info.stripePublicKey!="") && <MavButton onlyButton={true} text={strings.generateBillsWithLinkPayment} style={{marginLeft:20}} onPress={()=>{ this.generateBills(true) }} />}
          </View>

          {(this.state.enableSelected>0 && this.state.viewSelect=="waitBill" && this.state.waiting!=true && info.stripePublicKey!=undefined && info.stripePublicKey!="") && <Text style={{marginLeft:"10%", marginRight:"10%",color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "center", marginTop:10}}>{strings.generateBillsWithLinkPaymentMoreInfo}</Text>}

          <View style={{width:30,height:2}} />

        



       


          <MavAlert ref={alert => {this.alert = alert;}}/>


          



        <Modal
            animationType="slide"
            transparent={false}
            visible={(this.state.viewDebugInfo==true)}>
            <View style={{flex: 1,backgroundColor: style.backgroundColor,}}>
                <ScrollView style={{marginTop:50}}>

                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.clientName} textExplication={strings.name} textInputFlex={2} placeholder={example.name} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.clientName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.clientLastName} textExplication={strings.lastName} textInputFlex={2} placeholder={example.lastName} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.clientLastName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.racePlaceStartName} textExplication={strings.start} textInputFlex={2} placeholder={example.adress} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.racePlaceStartName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.racePlaceEndName} textExplication={strings.destination} textInputFlex={2} placeholder={example.adress} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.racePlaceEndName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.raceDateFixed} textExplication={strings.dateAndHour} textInputFlex={2} placeholder={"01/01/2020 - 12:00"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.raceDateFixed=text; this.setState({debugInfo:debug })}}/>

                 <MavTextInput style={{marginTop:5}} text={parseInt(this.state.debugInfo.estimateTimeValue/60)+""} textExplication={strings.durationInMinute} textInputFlex={2} placeholder={"20"} keyboardType={"numeric"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.estimateTimeValue=parseInt(text); if(debug.estimateTimeValue.toString()!="NaN") this.setState({debugInfo:debug })}}/>


                 

                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.driverName} textExplication={strings.driverName} textInputFlex={2} placeholder={"Paul"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.driverName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.driverLastName} textExplication={strings.driverLastName} textInputFlex={2} placeholder={"Durand"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.driverLastName=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.notes} textExplication={strings.notes} textInputFlex={2} placeholder={"Notes"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.notes=text; this.setState({debugInfo:debug })}}/>
                 <MavTextInput style={{marginTop:5}} text={this.state.debugInfo.forcePaiementExplication} textExplication={strings.forcePaiementExplication} textInputFlex={2} placeholder={"Paiement à bord"} onChangeText={(text)=>{ var debug=this.state.debugInfo; debug.forcePaiementExplication=text; this.setState({debugInfo:debug }) }}/>

                 <MavTextInput style={{marginTop:5}} keyboardType={"numeric"} textInputFlex={2} text={this.state.debugInfo.estimatePrice} textExplication={strings.price} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"50"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{
                      timer.setTimeout(generateUUID(), () => {
                          var test=this.state.debugInfo.estimatePrice.indexOf(this.state.money.symbole);
                          if(test==-1 && this.state.debugInfo.estimatePrice!="") {
                            var car=this.state.debugInfo.estimatePrice;
                            car=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+car+((this.state.money.position=="right")?(this.state.money.symbole):"")
                             var debug=this.state.debugInfo; 
                             debug.estimatePrice=car; 
                             this.setState({debugInfo:debug })
                          }
                      }, 2000);

                    


                    text=text.toString().replace(this.state.money.symbole,'')
                    text=text.toString().replace(",",'.')
                    var debug=this.state.debugInfo; 
                    debug.estimatePrice=text; 
                    this.setState({debugInfo:debug })
                  }}/>



                  <MavTextInput style={{marginTop:5}} keyboardType={"numeric"} textInputFlex={2} text={this.state.debugInfo.finalPriceDriverTTCEstimate} textExplication={strings.forceDriverPrice} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"50"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{
                      timer.setTimeout(generateUUID(), () => {
                          var test=this.state.debugInfo.finalPriceDriverTTCEstimate.indexOf(this.state.money.symbole);
                          if(test==-1 && this.state.debugInfo.finalPriceDriverTTCEstimate!="") {
                            var car=this.state.debugInfo.finalPriceDriverTTCEstimate;
                            car=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+car+((this.state.money.position=="right")?(this.state.money.symbole):"")
                             var debug=this.state.debugInfo; 
                             debug.finalPriceDriverTTCEstimate=car; 
                             this.setState({debugInfo:debug })
                          }
                      }, 2000);

                    


                    text=text.toString().replace(this.state.money.symbole,'')
                    text=text.toString().replace(",",'.')
                    var debug=this.state.debugInfo; 
                    debug.finalPriceDriverTTCEstimate=text; 
                    this.setState({debugInfo:debug })
                  }}/>


                 <MavButton text={strings.validate} style={{marginTop:40}} onPress={()=>{ 

                    var sendToFirebase=this.state.debugInfo;
                    sendToFirebase.newEdition=true; 
                    if(sendToFirebase.forcePaiementExplication==""|| sendToFirebase.forcePaiementExplication==undefined ) delete sendToFirebase.forcePaiementExplication
                    if(sendToFirebase.finalPriceDriverTTCEstimate=="" || sendToFirebase.finalPriceDriverTTCEstimate==undefined ) delete sendToFirebase.finalPriceDriverTTCEstimate
                    else {
                     sendToFirebase.finalPriceDriverTTCEstimate=sendToFirebase.finalPriceDriverTTCEstimate.replace(this.state.money.symbole,"")
                     sendToFirebase.finalPriceDriverTTCEstimate=parseFloat(sendToFirebase.finalPriceDriverTTCEstimate);
                    }
  
                    var newPrice=parseFloat(this.state.debugInfo.estimatePrice.toString().replace(this.state.money.symbole,''));
                    sendToFirebase.finalPrice=newPrice;
                    sendToFirebase.estimatePrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+newPrice+((this.state.money.position=="right")?(this.state.money.symbole):"")
                    sendToFirebase.status="WaitingInvoice"; 

                    

                    
                    var date=this.state.debugInfo.raceDateFixed;
                    date=new Date(date[6]+date[7]+date[8]+date[9]+'-'+date[3]+date[4]+'-'+date[0]+date[1]+'T'+date[13]+date[14]+':'+date[16]+date[17]+':00')
                    date=Date.parse(date)+date.getTimezoneOffset()*60000;
                    
                    sendToFirebase.raceDate=date;


                    console.log(sendToFirebase)
                    const fireInfo={} 
                    fireInfo['race/' +this.state.debugInfoID]=sendToFirebase
                    update(ref(getDatabase(firebase)), fireInfo)
                    
                    this.setState({viewDebugInfo:false})
                    

                  }}/>

                <MavButton text={strings.cancel} strokeMode={true} style={{marginTop:10}} onPress={()=>{ this.setState({viewDebugInfo:false})}}/>


                
                 


                </ScrollView>
            </View>

      </Modal>



      </ScrollView>


      {this.state.viewSearch==true && <ScrollView style={{width:Dimensions.get('window').width, height:Dimensions.get('window').height, backgroundColor:"rgba(0,0,0,0.8)", position:"absolute",}}> 
            
            <View style={{borderRadius: 20,borderWidth: 0, backgroundColor:style.backgroundColor,marginLeft:(Platform.OS=="web")?Dimensions.get('window').width-410:"5%",marginRight:(Platform.OS=="web")?undefined:"5%", marginBottom:100, marginTop:(Platform.OS=="web")?13:10,width:(Platform.OS=="web")?400:undefined  }}>  
                <MavSearch noMargin={true} loading={this.state.searchBill.loading} search={this.state.searchBill.text} searchExplication={strings.selectBillNumber} background={style.backgroundColor} onSearch={data => {var searchBill={text:data, loading:true}; this.setState({searchBill:searchBill},() =>{
                  if(searchBillWithNumberTimer!=undefined) timer.clearTimeout(searchBillWithNumberTimer); 
                  searchBillWithNumberTimer=timer.setTimeout("searchBillWithNumber", () => { this.searchBillWithNumber()}, 350); 

                }) }} />

                {(this.state.searchBill.result!=undefined && this.state.searchBill.result.length==0 && this.state.searchBill.text!="") && <View style={{alignItems:"center", marginTop:10, marginBottom:10}}>

                  <Image source={(style.mode=="dark")?require('../assets/driver_cancel_light.png'):require('../assets/driver_cancel_dark.png')} style={{ width: 40, height: 40, }}/>
                  <Text style={{textAlign: 'center',fontSize: style.textInputFontSize*1.1,color: style.textInputColor,marginTop:10,fontWeight: 'bold',}}>{ strings.nothingToView }</Text>
                  

                </View>}

                {(this.state.searchBill.result!=undefined && this.state.searchBill.result.length>0) && <View style={{alignItems:"center",marginTop:10, marginBottom:10}}>
                    {this.state.searchBill.result.map((rowData,i)=>(
                        <View style={{width:"100%", alignItems:"center", marginBottom:20}}>
                          <BookingView  viewPDFFile={() => { this.viewPDFFile(rowData.downloadLink) }} mode={"revenueSearch"} enableDriverNameInRace={this.state.driver} data={rowData} style={{width:"90%"}}/>
                          {(i<this.state.searchBill.result.length-1) && <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: 10,width:"90%"}}/>}
                        </View>
                        ))}

                 </View>}


                 {(Platform.OS=="web") && <View style={{alignItems:"center",justifyContent:"center",marginTop:10,marginBottom:10}}>
                  <MavButton text={strings.close} strokeMode={true} onlyButton={true} onPress={()=>{  this.setState({viewSearch:false}) }}/>
              </View>}

            </View>


          </ScrollView>}

      </View>
      }</StyleContext.Consumer>
      
    );
  }
}



export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

